/**
 * Generated from MayaAngelouCutouts.fla
 */
export function MayaAngelouCutouts(this: IMayaAngelouCutouts) {
	const cutouts = this.cutouts;
	if (!cutouts[0] && cutouts.elementFactory) {
		cutouts[0] = cutouts.elementFactory(0,undefined);
	}
	if (cutouts[0]) {
		MayaAngelouCutouts_ang_afriend_berbie1.call(cutouts[0] as IMayaAngelouCutouts_ang_afriend_berbie1);
		cutouts[0].x = 777;
		cutouts[0].y = 512.5;
		if (cutouts[0].onLayout) cutouts[0].onLayout();
	}
	if (!cutouts[1] && cutouts.elementFactory) {
		cutouts[1] = cutouts.elementFactory(1,undefined);
	}
	if (cutouts[1]) {
		MayaAngelouCutouts_ang_afriend_drz1.call(cutouts[1] as IMayaAngelouCutouts_ang_afriend_drz1);
		cutouts[1].x = 766;
		cutouts[1].y = 610;
		if (cutouts[1].onLayout) cutouts[1].onLayout();
	}
	if (!cutouts[2] && cutouts.elementFactory) {
		cutouts[2] = cutouts.elementFactory(2,undefined);
	}
	if (cutouts[2]) {
		MayaAngelouCutouts_ang_afriend_hearts1.call(cutouts[2] as IMayaAngelouCutouts_ang_afriend_hearts1);
		cutouts[2].x = 714;
		cutouts[2].y = 584;
		if (cutouts[2].onLayout) cutouts[2].onLayout();
	}
	if (!cutouts[3] && cutouts.elementFactory) {
		cutouts[3] = cutouts.elementFactory(3,undefined);
	}
	if (cutouts[3]) {
		MayaAngelouCutouts_ang_afriend_icecream1.call(cutouts[3] as IMayaAngelouCutouts_ang_afriend_icecream1);
		cutouts[3].x = 790.5;
		cutouts[3].y = 566;
		if (cutouts[3].onLayout) cutouts[3].onLayout();
	}
	if (!cutouts[4] && cutouts.elementFactory) {
		cutouts[4] = cutouts.elementFactory(4,undefined);
	}
	if (cutouts[4]) {
		MayaAngelouCutouts_ang_art1.call(cutouts[4] as IMayaAngelouCutouts_ang_art1);
		cutouts[4].x = 760;
		cutouts[4].y = 280.5;
		if (cutouts[4].onLayout) cutouts[4].onLayout();
	}
	if (!cutouts[5] && cutouts.elementFactory) {
		cutouts[5] = cutouts.elementFactory(5,undefined);
	}
	if (cutouts[5]) {
		MayaAngelouCutouts_ang_art_drz1.call(cutouts[5] as IMayaAngelouCutouts_ang_art_drz1);
		cutouts[5].x = 836;
		cutouts[5].y = 653.5;
		if (cutouts[5].onLayout) cutouts[5].onLayout();
	}
	if (!cutouts[6] && cutouts.elementFactory) {
		cutouts[6] = cutouts.elementFactory(6,undefined);
	}
	if (cutouts[6]) {
		MayaAngelouCutouts_ang_balloon1.call(cutouts[6] as IMayaAngelouCutouts_ang_balloon1);
		cutouts[6].x = 591;
		cutouts[6].y = 200.5;
		if (cutouts[6].onLayout) cutouts[6].onLayout();
	}
	if (!cutouts[7] && cutouts.elementFactory) {
		cutouts[7] = cutouts.elementFactory(7,undefined);
	}
	if (cutouts[7]) {
		MayaAngelouCutouts_ang_balloon_drz1.call(cutouts[7] as IMayaAngelouCutouts_ang_balloon_drz1);
		cutouts[7].x = 776;
		cutouts[7].y = 556.5;
		if (cutouts[7].onLayout) cutouts[7].onLayout();
	}
	if (!cutouts[8] && cutouts.elementFactory) {
		cutouts[8] = cutouts.elementFactory(8,undefined);
	}
	if (cutouts[8]) {
		MayaAngelouCutouts_ang_bread1.call(cutouts[8] as IMayaAngelouCutouts_ang_bread1);
		cutouts[8].x = 741;
		cutouts[8].y = 643;
		if (cutouts[8].onLayout) cutouts[8].onLayout();
	}
	if (!cutouts[9] && cutouts.elementFactory) {
		cutouts[9] = cutouts.elementFactory(9,undefined);
	}
	if (cutouts[9]) {
		MayaAngelouCutouts_ang_bread_drz1.call(cutouts[9] as IMayaAngelouCutouts_ang_bread_drz1);
		cutouts[9].x = 832.5;
		cutouts[9].y = 576.5;
		if (cutouts[9].onLayout) cutouts[9].onLayout();
	}
	if (!cutouts[10] && cutouts.elementFactory) {
		cutouts[10] = cutouts.elementFactory(10,undefined);
	}
	if (cutouts[10]) {
		MayaAngelouCutouts_ang_counterpart1.call(cutouts[10] as IMayaAngelouCutouts_ang_counterpart1);
		cutouts[10].x = 645.5;
		cutouts[10].y = 438;
		if (cutouts[10].onLayout) cutouts[10].onLayout();
	}
	if (!cutouts[11] && cutouts.elementFactory) {
		cutouts[11] = cutouts.elementFactory(11,undefined);
	}
	if (cutouts[11]) {
		MayaAngelouCutouts_ang_counterpart_drz_11.call(cutouts[11] as IMayaAngelouCutouts_ang_counterpart_drz_11);
		cutouts[11].x = 917.5;
		cutouts[11].y = 657.5;
		if (cutouts[11].onLayout) cutouts[11].onLayout();
	}
	if (!cutouts[12] && cutouts.elementFactory) {
		cutouts[12] = cutouts.elementFactory(12,undefined);
	}
	if (cutouts[12]) {
		MayaAngelouCutouts_ang_counterpart_drz_21.call(cutouts[12] as IMayaAngelouCutouts_ang_counterpart_drz_21);
		cutouts[12].x = 725;
		cutouts[12].y = 551;
		if (cutouts[12].onLayout) cutouts[12].onLayout();
	}
	if (!cutouts[13] && cutouts.elementFactory) {
		cutouts[13] = cutouts.elementFactory(13,undefined);
	}
	if (cutouts[13]) {
		MayaAngelouCutouts_ang_dance_stereo1.call(cutouts[13] as IMayaAngelouCutouts_ang_dance_stereo1);
		cutouts[13].x = 823.5;
		cutouts[13].y = 655.5;
		if (cutouts[13].onLayout) cutouts[13].onLayout();
	}
	if (!cutouts[14] && cutouts.elementFactory) {
		cutouts[14] = cutouts.elementFactory(14,undefined);
	}
	if (cutouts[14]) {
		MayaAngelouCutouts_ang_flower1.call(cutouts[14] as IMayaAngelouCutouts_ang_flower1);
		cutouts[14].x = 858;
		cutouts[14].y = 566.5;
		if (cutouts[14].onLayout) cutouts[14].onLayout();
	}
	if (!cutouts[15] && cutouts.elementFactory) {
		cutouts[15] = cutouts.elementFactory(15,undefined);
	}
	if (cutouts[15]) {
		MayaAngelouCutouts_ang_flower_drz1.call(cutouts[15] as IMayaAngelouCutouts_ang_flower_drz1);
		cutouts[15].x = 827.5;
		cutouts[15].y = 581.5;
		if (cutouts[15].onLayout) cutouts[15].onLayout();
	}
	if (!cutouts[16] && cutouts.elementFactory) {
		cutouts[16] = cutouts.elementFactory(16,undefined);
	}
	if (cutouts[16]) {
		MayaAngelouCutouts_ang_flower_left1.call(cutouts[16] as IMayaAngelouCutouts_ang_flower_left1);
		cutouts[16].x = 748.5;
		cutouts[16].y = 458;
		if (cutouts[16].onLayout) cutouts[16].onLayout();
	}
	if (!cutouts[17] && cutouts.elementFactory) {
		cutouts[17] = cutouts.elementFactory(17,undefined);
	}
	if (cutouts[17]) {
		MayaAngelouCutouts_ang_flower_right1.call(cutouts[17] as IMayaAngelouCutouts_ang_flower_right1);
		cutouts[17].x = 684.5;
		cutouts[17].y = 399.5;
		if (cutouts[17].onLayout) cutouts[17].onLayout();
	}
	if (!cutouts[18] && cutouts.elementFactory) {
		cutouts[18] = cutouts.elementFactory(18,undefined);
	}
	if (cutouts[18]) {
		MayaAngelouCutouts_ang_heart_11.call(cutouts[18] as IMayaAngelouCutouts_ang_heart_11);
		cutouts[18].x = 653;
		cutouts[18].y = 475.5;
		if (cutouts[18].onLayout) cutouts[18].onLayout();
	}
	if (!cutouts[19] && cutouts.elementFactory) {
		cutouts[19] = cutouts.elementFactory(19,undefined);
	}
	if (cutouts[19]) {
		MayaAngelouCutouts_ang_heart_21.call(cutouts[19] as IMayaAngelouCutouts_ang_heart_21);
		cutouts[19].x = 796.5;
		cutouts[19].y = 578;
		if (cutouts[19].onLayout) cutouts[19].onLayout();
	}
	if (!cutouts[20] && cutouts.elementFactory) {
		cutouts[20] = cutouts.elementFactory(20,undefined);
	}
	if (cutouts[20]) {
		MayaAngelouCutouts_ang_heart_31.call(cutouts[20] as IMayaAngelouCutouts_ang_heart_31);
		cutouts[20].x = 842.5;
		cutouts[20].y = 610.5;
		if (cutouts[20].onLayout) cutouts[20].onLayout();
	}
	if (!cutouts[21] && cutouts.elementFactory) {
		cutouts[21] = cutouts.elementFactory(21,undefined);
	}
	if (cutouts[21]) {
		MayaAngelouCutouts_ang_heart_drz1.call(cutouts[21] as IMayaAngelouCutouts_ang_heart_drz1);
		cutouts[21].x = 896.5;
		cutouts[21].y = 629.5;
		if (cutouts[21].onLayout) cutouts[21].onLayout();
	}
	if (!cutouts[22] && cutouts.elementFactory) {
		cutouts[22] = cutouts.elementFactory(22,undefined);
	}
	if (cutouts[22]) {
		MayaAngelouCutouts_ang_heart_drz_front1.call(cutouts[22] as IMayaAngelouCutouts_ang_heart_drz_front1);
		cutouts[22].x = 934;
		cutouts[22].y = 715;
		if (cutouts[22].onLayout) cutouts[22].onLayout();
	}
	if (!cutouts[23] && cutouts.elementFactory) {
		cutouts[23] = cutouts.elementFactory(23,undefined);
	}
	if (cutouts[23]) {
		MayaAngelouCutouts_ang_lovedaton1.call(cutouts[23] as IMayaAngelouCutouts_ang_lovedaton1);
		cutouts[23].x = 620;
		cutouts[23].y = 339;
		if (cutouts[23].onLayout) cutouts[23].onLayout();
	}
	if (!cutouts[24] && cutouts.elementFactory) {
		cutouts[24] = cutouts.elementFactory(24,undefined);
	}
	if (cutouts[24]) {
		MayaAngelouCutouts_ang_lovedaton_heart11.call(cutouts[24] as IMayaAngelouCutouts_ang_lovedaton_heart11);
		cutouts[24].x = 942.5;
		cutouts[24].y = 700;
		if (cutouts[24].onLayout) cutouts[24].onLayout();
	}
	if (!cutouts[25] && cutouts.elementFactory) {
		cutouts[25] = cutouts.elementFactory(25,undefined);
	}
	if (cutouts[25]) {
		MayaAngelouCutouts_ang_lovedaton_heart21.call(cutouts[25] as IMayaAngelouCutouts_ang_lovedaton_heart21);
		cutouts[25].x = 965.5;
		cutouts[25].y = 717;
		if (cutouts[25].onLayout) cutouts[25].onLayout();
	}
	if (!cutouts[26] && cutouts.elementFactory) {
		cutouts[26] = cutouts.elementFactory(26,undefined);
	}
	if (cutouts[26]) {
		MayaAngelouCutouts_ang_lovedaton_heart31.call(cutouts[26] as IMayaAngelouCutouts_ang_lovedaton_heart31);
		cutouts[26].x = 946.5;
		cutouts[26].y = 700.5;
		if (cutouts[26].onLayout) cutouts[26].onLayout();
	}
	if (!cutouts[27] && cutouts.elementFactory) {
		cutouts[27] = cutouts.elementFactory(27,undefined);
	}
	if (cutouts[27]) {
		MayaAngelouCutouts_ang_lovedaton_heart41.call(cutouts[27] as IMayaAngelouCutouts_ang_lovedaton_heart41);
		cutouts[27].x = 900.5;
		cutouts[27].y = 664;
		if (cutouts[27].onLayout) cutouts[27].onLayout();
	}
	if (!cutouts[28] && cutouts.elementFactory) {
		cutouts[28] = cutouts.elementFactory(28,undefined);
	}
	if (cutouts[28]) {
		MayaAngelouCutouts_ang_marshmallowsbg1.call(cutouts[28] as IMayaAngelouCutouts_ang_marshmallowsbg1);
		cutouts[28].x = 755.5;
		cutouts[28].y = 481.5;
		if (cutouts[28].onLayout) cutouts[28].onLayout();
	}
	if (!cutouts[29] && cutouts.elementFactory) {
		cutouts[29] = cutouts.elementFactory(29,undefined);
	}
	if (cutouts[29]) {
		MayaAngelouCutouts_ang_moon1.call(cutouts[29] as IMayaAngelouCutouts_ang_moon1);
		cutouts[29].x = 703.5;
		cutouts[29].y = 447.5;
		if (cutouts[29].onLayout) cutouts[29].onLayout();
	}
	if (!cutouts[30] && cutouts.elementFactory) {
		cutouts[30] = cutouts.elementFactory(30,undefined);
	}
	if (cutouts[30]) {
		MayaAngelouCutouts_ang_moon_drz1.call(cutouts[30] as IMayaAngelouCutouts_ang_moon_drz1);
		cutouts[30].x = 869;
		cutouts[30].y = 628.5;
		if (cutouts[30].onLayout) cutouts[30].onLayout();
	}
	if (!cutouts[31] && cutouts.elementFactory) {
		cutouts[31] = cutouts.elementFactory(31,undefined);
	}
	if (cutouts[31]) {
		MayaAngelouCutouts_ang_moon_drz_front1.call(cutouts[31] as IMayaAngelouCutouts_ang_moon_drz_front1);
		cutouts[31].x = 869;
		cutouts[31].y = 628.5;
		if (cutouts[31].onLayout) cutouts[31].onLayout();
	}
	if (!cutouts[32] && cutouts.elementFactory) {
		cutouts[32] = cutouts.elementFactory(32,undefined);
	}
	if (cutouts[32]) {
		MayaAngelouCutouts_ang_numberone1.call(cutouts[32] as IMayaAngelouCutouts_ang_numberone1);
		cutouts[32].x = 640.5;
		cutouts[32].y = 338.5;
		if (cutouts[32].onLayout) cutouts[32].onLayout();
	}
	if (!cutouts[33] && cutouts.elementFactory) {
		cutouts[33] = cutouts.elementFactory(33,undefined);
	}
	if (cutouts[33]) {
		MayaAngelouCutouts_ang_onionrings1.call(cutouts[33] as IMayaAngelouCutouts_ang_onionrings1);
		cutouts[33].x = 638;
		cutouts[33].y = 635;
		if (cutouts[33].onLayout) cutouts[33].onLayout();
	}
	if (!cutouts[34] && cutouts.elementFactory) {
		cutouts[34] = cutouts.elementFactory(34,undefined);
	}
	if (cutouts[34]) {
		MayaAngelouCutouts_ang_onionrings_drz1.call(cutouts[34] as IMayaAngelouCutouts_ang_onionrings_drz1);
		cutouts[34].x = 773;
		cutouts[34].y = 591;
		if (cutouts[34].onLayout) cutouts[34].onLayout();
	}
	if (!cutouts[35] && cutouts.elementFactory) {
		cutouts[35] = cutouts.elementFactory(35,undefined);
	}
	if (cutouts[35]) {
		MayaAngelouCutouts_ang_pie1.call(cutouts[35] as IMayaAngelouCutouts_ang_pie1);
		cutouts[35].x = 722.8;
		cutouts[35].y = 613.25;
		if (cutouts[35].onLayout) cutouts[35].onLayout();
	}
	if (!cutouts[36] && cutouts.elementFactory) {
		cutouts[36] = cutouts.elementFactory(36,undefined);
	}
	if (cutouts[36]) {
		MayaAngelouCutouts_ang_marshmallows11.call(cutouts[36] as IMayaAngelouCutouts_ang_marshmallows11);
		cutouts[36].x = 908;
		cutouts[36].y = 690.5;
		if (cutouts[36].onLayout) cutouts[36].onLayout();
	}
	if (!cutouts[37] && cutouts.elementFactory) {
		cutouts[37] = cutouts.elementFactory(37,undefined);
	}
	if (cutouts[37]) {
		MayaAngelouCutouts_ang_marshmallows21.call(cutouts[37] as IMayaAngelouCutouts_ang_marshmallows21);
		cutouts[37].x = 907.5;
		cutouts[37].y = 688.5;
		if (cutouts[37].onLayout) cutouts[37].onLayout();
	}
	if (!cutouts[38] && cutouts.elementFactory) {
		cutouts[38] = cutouts.elementFactory(38,undefined);
	}
	if (cutouts[38]) {
		MayaAngelouCutouts_ang_marshmallows31.call(cutouts[38] as IMayaAngelouCutouts_ang_marshmallows31);
		cutouts[38].x = 868;
		cutouts[38].y = 678.5;
		if (cutouts[38].onLayout) cutouts[38].onLayout();
	}
	if (!cutouts[39] && cutouts.elementFactory) {
		cutouts[39] = cutouts.elementFactory(39,undefined);
	}
	if (cutouts[39]) {
		MayaAngelouCutouts_ang_pie_drz1.call(cutouts[39] as IMayaAngelouCutouts_ang_pie_drz1);
		cutouts[39].x = 897.5;
		cutouts[39].y = 651;
		if (cutouts[39].onLayout) cutouts[39].onLayout();
	}
	if (!cutouts[40] && cutouts.elementFactory) {
		cutouts[40] = cutouts.elementFactory(40,undefined);
	}
	if (cutouts[40]) {
		MayaAngelouCutouts_ang_pillow1.call(cutouts[40] as IMayaAngelouCutouts_ang_pillow1);
		cutouts[40].x = 612.5;
		cutouts[40].y = 509;
		if (cutouts[40].onLayout) cutouts[40].onLayout();
	}
	if (!cutouts[41] && cutouts.elementFactory) {
		cutouts[41] = cutouts.elementFactory(41,undefined);
	}
	if (cutouts[41]) {
		MayaAngelouCutouts_ang_pillow_drz1.call(cutouts[41] as IMayaAngelouCutouts_ang_pillow_drz1);
		cutouts[41].x = 784.5;
		cutouts[41].y = 577.5;
		if (cutouts[41].onLayout) cutouts[41].onLayout();
	}
	if (!cutouts[42] && cutouts.elementFactory) {
		cutouts[42] = cutouts.elementFactory(42,undefined);
	}
	if (cutouts[42]) {
		MayaAngelouCutouts_ang_pizzatower1.call(cutouts[42] as IMayaAngelouCutouts_ang_pizzatower1);
		cutouts[42].x = 289.5;
		cutouts[42].y = 400;
		if (cutouts[42].onLayout) cutouts[42].onLayout();
	}
	if (!cutouts[43] && cutouts.elementFactory) {
		cutouts[43] = cutouts.elementFactory(43,undefined);
	}
	if (cutouts[43]) {
		MayaAngelouCutouts_ang_pizzatower2.call(cutouts[43] as IMayaAngelouCutouts_ang_pizzatower2);
		cutouts[43].x = 289.5;
		cutouts[43].y = 400;
		if (cutouts[43].onLayout) cutouts[43].onLayout();
	}
	if (!cutouts[44] && cutouts.elementFactory) {
		cutouts[44] = cutouts.elementFactory(44,undefined);
	}
	if (cutouts[44]) {
		MayaAngelouCutouts_ang_pizzatower__xavier1.call(cutouts[44] as IMayaAngelouCutouts_ang_pizzatower__xavier1);
		cutouts[44].x = 873.5;
		cutouts[44].y = 512.5;
		if (cutouts[44].onLayout) cutouts[44].onLayout();
	}
	if (!cutouts[45] && cutouts.elementFactory) {
		cutouts[45] = cutouts.elementFactory(45,undefined);
	}
	if (cutouts[45]) {
		MayaAngelouCutouts_ang_pizzatower_brad1.call(cutouts[45] as IMayaAngelouCutouts_ang_pizzatower_brad1);
		cutouts[45].x = 877;
		cutouts[45].y = 521.5;
		if (cutouts[45].onLayout) cutouts[45].onLayout();
	}
	if (!cutouts[46] && cutouts.elementFactory) {
		cutouts[46] = cutouts.elementFactory(46,undefined);
	}
	if (cutouts[46]) {
		MayaAngelouCutouts_ang_pizzatower_drz1.call(cutouts[46] as IMayaAngelouCutouts_ang_pizzatower_drz1);
		cutouts[46].x = 906;
		cutouts[46].y = 661.5;
		if (cutouts[46].onLayout) cutouts[46].onLayout();
	}
	if (!cutouts[47] && cutouts.elementFactory) {
		cutouts[47] = cutouts.elementFactory(47,undefined);
	}
	if (cutouts[47]) {
		MayaAngelouCutouts_ang_pizzatower_yadina1.call(cutouts[47] as IMayaAngelouCutouts_ang_pizzatower_yadina1);
		cutouts[47].x = 824;
		cutouts[47].y = 540.5;
		if (cutouts[47].onLayout) cutouts[47].onLayout();
	}
	if (!cutouts[48] && cutouts.elementFactory) {
		cutouts[48] = cutouts.elementFactory(48,undefined);
	}
	if (cutouts[48]) {
		MayaAngelouCutouts_ang_raccoon1.call(cutouts[48] as IMayaAngelouCutouts_ang_raccoon1);
		cutouts[48].x = 764;
		cutouts[48].y = 420;
		if (cutouts[48].onLayout) cutouts[48].onLayout();
	}
	if (!cutouts[49] && cutouts.elementFactory) {
		cutouts[49] = cutouts.elementFactory(49,undefined);
	}
	if (cutouts[49]) {
		MayaAngelouCutouts_ang_raccoon_drz1.call(cutouts[49] as IMayaAngelouCutouts_ang_raccoon_drz1);
		cutouts[49].x = 768.5;
		cutouts[49].y = 510.5;
		if (cutouts[49].onLayout) cutouts[49].onLayout();
	}
	if (!cutouts[50] && cutouts.elementFactory) {
		cutouts[50] = cutouts.elementFactory(50,undefined);
	}
	if (cutouts[50]) {
		MayaAngelouCutouts_ang_raccoon_drz_front1.call(cutouts[50] as IMayaAngelouCutouts_ang_raccoon_drz_front1);
		cutouts[50].x = 768.5;
		cutouts[50].y = 510.5;
		if (cutouts[50].onLayout) cutouts[50].onLayout();
	}
	if (!cutouts[51] && cutouts.elementFactory) {
		cutouts[51] = cutouts.elementFactory(51,undefined);
	}
	if (cutouts[51]) {
		MayaAngelouCutouts_ang_sandwich1.call(cutouts[51] as IMayaAngelouCutouts_ang_sandwich1);
		cutouts[51].x = 632.5;
		cutouts[51].y = 451;
		if (cutouts[51].onLayout) cutouts[51].onLayout();
	}
	if (!cutouts[52] && cutouts.elementFactory) {
		cutouts[52] = cutouts.elementFactory(52,undefined);
	}
	if (cutouts[52]) {
		MayaAngelouCutouts_ang_sandwich_drz1.call(cutouts[52] as IMayaAngelouCutouts_ang_sandwich_drz1);
		cutouts[52].x = 831.5;
		cutouts[52].y = 597;
		if (cutouts[52].onLayout) cutouts[52].onLayout();
	}
	if (!cutouts[53] && cutouts.elementFactory) {
		cutouts[53] = cutouts.elementFactory(53,undefined);
	}
	if (cutouts[53]) {
		MayaAngelouCutouts_ang_sea_bubbles11.call(cutouts[53] as IMayaAngelouCutouts_ang_sea_bubbles11);
		cutouts[53].x = 872;
		cutouts[53].y = 554.5;
		if (cutouts[53].onLayout) cutouts[53].onLayout();
	}
	if (!cutouts[54] && cutouts.elementFactory) {
		cutouts[54] = cutouts.elementFactory(54,undefined);
	}
	if (cutouts[54]) {
		MayaAngelouCutouts_ang_sea_bubbles21.call(cutouts[54] as IMayaAngelouCutouts_ang_sea_bubbles21);
		cutouts[54].x = 774.5;
		cutouts[54].y = 554.5;
		if (cutouts[54].onLayout) cutouts[54].onLayout();
	}
	if (!cutouts[55] && cutouts.elementFactory) {
		cutouts[55] = cutouts.elementFactory(55,undefined);
	}
	if (cutouts[55]) {
		MayaAngelouCutouts_ang_sea_drz1.call(cutouts[55] as IMayaAngelouCutouts_ang_sea_drz1);
		cutouts[55].x = 829.5;
		cutouts[55].y = 601.5;
		if (cutouts[55].onLayout) cutouts[55].onLayout();
	}
	if (!cutouts[56] && cutouts.elementFactory) {
		cutouts[56] = cutouts.elementFactory(56,undefined);
	}
	if (cutouts[56]) {
		MayaAngelouCutouts_ang_sea_left1.call(cutouts[56] as IMayaAngelouCutouts_ang_sea_left1);
		cutouts[56].x = 734.5;
		cutouts[56].y = 456;
		if (cutouts[56].onLayout) cutouts[56].onLayout();
	}
	if (!cutouts[57] && cutouts.elementFactory) {
		cutouts[57] = cutouts.elementFactory(57,undefined);
	}
	if (cutouts[57]) {
		MayaAngelouCutouts_ang_sea_fish1.call(cutouts[57] as IMayaAngelouCutouts_ang_sea_fish1);
		cutouts[57].x = 734.5;
		cutouts[57].y = 456;
		if (cutouts[57].onLayout) cutouts[57].onLayout();
	}
	if (!cutouts[58] && cutouts.elementFactory) {
		cutouts[58] = cutouts.elementFactory(58,undefined);
	}
	if (cutouts[58]) {
		MayaAngelouCutouts_ang_sea_right1.call(cutouts[58] as IMayaAngelouCutouts_ang_sea_right1);
		cutouts[58].x = 690.5;
		cutouts[58].y = 595;
		if (cutouts[58].onLayout) cutouts[58].onLayout();
	}
	if (!cutouts[59] && cutouts.elementFactory) {
		cutouts[59] = cutouts.elementFactory(59,undefined);
	}
	if (cutouts[59]) {
		MayaAngelouCutouts_ang_sea_whale1.call(cutouts[59] as IMayaAngelouCutouts_ang_sea_whale1);
		cutouts[59].x = 721;
		cutouts[59].y = 612;
		if (cutouts[59].onLayout) cutouts[59].onLayout();
	}
	if (!cutouts[60] && cutouts.elementFactory) {
		cutouts[60] = cutouts.elementFactory(60,undefined);
	}
	if (cutouts[60]) {
		MayaAngelouCutouts_ang_shower1.call(cutouts[60] as IMayaAngelouCutouts_ang_shower1);
		cutouts[60].x = 526.5;
		cutouts[60].y = 256.5;
		if (cutouts[60].onLayout) cutouts[60].onLayout();
	}
	if (!cutouts[61] && cutouts.elementFactory) {
		cutouts[61] = cutouts.elementFactory(61,undefined);
	}
	if (cutouts[61]) {
		MayaAngelouCutouts_ang_shower_dzr1.call(cutouts[61] as IMayaAngelouCutouts_ang_shower_dzr1);
		cutouts[61].x = 876;
		cutouts[61].y = 664.5;
		if (cutouts[61].onLayout) cutouts[61].onLayout();
	}
	if (!cutouts[62] && cutouts.elementFactory) {
		cutouts[62] = cutouts.elementFactory(62,undefined);
	}
	if (cutouts[62]) {
		MayaAngelouCutouts_ang_shower_dzr_front1.call(cutouts[62] as IMayaAngelouCutouts_ang_shower_dzr_front1);
		cutouts[62].x = 981;
		cutouts[62].y = 734.5;
		if (cutouts[62].onLayout) cutouts[62].onLayout();
	}
	if (!cutouts[63] && cutouts.elementFactory) {
		cutouts[63] = cutouts.elementFactory(63,undefined);
	}
	if (cutouts[63]) {
		MayaAngelouCutouts_ang_shower_note11.call(cutouts[63] as IMayaAngelouCutouts_ang_shower_note11);
		cutouts[63].x = 995.5;
		cutouts[63].y = 715.5;
		if (cutouts[63].onLayout) cutouts[63].onLayout();
	}
	if (!cutouts[64] && cutouts.elementFactory) {
		cutouts[64] = cutouts.elementFactory(64,undefined);
	}
	if (cutouts[64]) {
		MayaAngelouCutouts_ang_shower_note21.call(cutouts[64] as IMayaAngelouCutouts_ang_shower_note21);
		cutouts[64].x = 987;
		cutouts[64].y = 721;
		if (cutouts[64].onLayout) cutouts[64].onLayout();
	}
	if (!cutouts[65] && cutouts.elementFactory) {
		cutouts[65] = cutouts.elementFactory(65,undefined);
	}
	if (cutouts[65]) {
		MayaAngelouCutouts_ang_shower_notes1.call(cutouts[65] as IMayaAngelouCutouts_ang_shower_notes1);
		cutouts[65].x = 875;
		cutouts[65].y = 459;
		if (cutouts[65].onLayout) cutouts[65].onLayout();
	}
	if (!cutouts[66] && cutouts.elementFactory) {
		cutouts[66] = cutouts.elementFactory(66,undefined);
	}
	if (cutouts[66]) {
		MayaAngelouCutouts_ang_sittingstill1.call(cutouts[66] as IMayaAngelouCutouts_ang_sittingstill1);
		cutouts[66].x = 181;
		cutouts[66].y = 407;
		if (cutouts[66].onLayout) cutouts[66].onLayout();
	}
	if (!cutouts[67] && cutouts.elementFactory) {
		cutouts[67] = cutouts.elementFactory(67,undefined);
	}
	if (cutouts[67]) {
		MayaAngelouCutouts_ang_sittingstill_clock1.call(cutouts[67] as IMayaAngelouCutouts_ang_sittingstill_clock1);
		cutouts[67].x = 877;
		cutouts[67].y = 625;
		if (cutouts[67].onLayout) cutouts[67].onLayout();
	}
	if (!cutouts[68] && cutouts.elementFactory) {
		cutouts[68] = cutouts.elementFactory(68,undefined);
	}
	if (cutouts[68]) {
		MayaAngelouCutouts_ang_sittingstill_clock_handHr1.call(cutouts[68] as IMayaAngelouCutouts_ang_sittingstill_clock_handHr1);
		cutouts[68].x = 1021;
		cutouts[68].y = 745;
		if (cutouts[68].onLayout) cutouts[68].onLayout();
	}
	if (!cutouts[69] && cutouts.elementFactory) {
		cutouts[69] = cutouts.elementFactory(69,undefined);
	}
	if (cutouts[69]) {
		MayaAngelouCutouts_ang_sittingstill_clock_handMin1.call(cutouts[69] as IMayaAngelouCutouts_ang_sittingstill_clock_handMin1);
		cutouts[69].x = 1021;
		cutouts[69].y = 732.5;
		if (cutouts[69].onLayout) cutouts[69].onLayout();
	}
	if (!cutouts[70] && cutouts.elementFactory) {
		cutouts[70] = cutouts.elementFactory(70,undefined);
	}
	if (cutouts[70]) {
		MayaAngelouCutouts_ang_sittingstill_drz1.call(cutouts[70] as IMayaAngelouCutouts_ang_sittingstill_drz1);
		cutouts[70].x = 916;
		cutouts[70].y = 631;
		if (cutouts[70].onLayout) cutouts[70].onLayout();
	}
	if (!cutouts[71] && cutouts.elementFactory) {
		cutouts[71] = cutouts.elementFactory(71,undefined);
	}
	if (cutouts[71]) {
		MayaAngelouCutouts_ang_sled1.call(cutouts[71] as IMayaAngelouCutouts_ang_sled1);
		cutouts[71].x = 461;
		cutouts[71].y = 634.5;
		if (cutouts[71].onLayout) cutouts[71].onLayout();
	}
	if (!cutouts[72] && cutouts.elementFactory) {
		cutouts[72] = cutouts.elementFactory(72,undefined);
	}
	if (cutouts[72]) {
		MayaAngelouCutouts_ang_sled_drz1.call(cutouts[72] as IMayaAngelouCutouts_ang_sled_drz1);
		cutouts[72].x = 829.5;
		cutouts[72].y = 573;
		if (cutouts[72].onLayout) cutouts[72].onLayout();
	}
	if (!cutouts[73] && cutouts.elementFactory) {
		cutouts[73] = cutouts.elementFactory(73,undefined);
	}
	if (cutouts[73]) {
		MayaAngelouCutouts_ang_sled_pillow_back1.call(cutouts[73] as IMayaAngelouCutouts_ang_sled_pillow_back1);
		cutouts[73].x = 191;
		cutouts[73].y = 625.5;
		if (cutouts[73].onLayout) cutouts[73].onLayout();
	}
	if (!cutouts[74] && cutouts.elementFactory) {
		cutouts[74] = cutouts.elementFactory(74,undefined);
	}
	if (cutouts[74]) {
		MayaAngelouCutouts_ang_sled_pillow_front1.call(cutouts[74] as IMayaAngelouCutouts_ang_sled_pillow_front1);
		cutouts[74].x = 737.5;
		cutouts[74].y = 606.5;
		if (cutouts[74].onLayout) cutouts[74].onLayout();
	}
	if (!cutouts[75] && cutouts.elementFactory) {
		cutouts[75] = cutouts.elementFactory(75,undefined);
	}
	if (cutouts[75]) {
		MayaAngelouCutouts_ang_sleepyhead_bed1.call(cutouts[75] as IMayaAngelouCutouts_ang_sleepyhead_bed1);
		cutouts[75].x = 534;
		cutouts[75].y = 559;
		if (cutouts[75].onLayout) cutouts[75].onLayout();
	}
	if (!cutouts[76] && cutouts.elementFactory) {
		cutouts[76] = cutouts.elementFactory(76,undefined);
	}
	if (cutouts[76]) {
		MayaAngelouCutouts_ang_sleepyhead_drz1.call(cutouts[76] as IMayaAngelouCutouts_ang_sleepyhead_drz1);
		cutouts[76].x = 769;
		cutouts[76].y = 441.5;
		if (cutouts[76].onLayout) cutouts[76].onLayout();
	}
	if (!cutouts[77] && cutouts.elementFactory) {
		cutouts[77] = cutouts.elementFactory(77,undefined);
	}
	if (cutouts[77]) {
		MayaAngelouCutouts_ang_sleepyhead_z1.call(cutouts[77] as IMayaAngelouCutouts_ang_sleepyhead_z1);
		cutouts[77].x = 997.5;
		cutouts[77].y = 726.5;
		if (cutouts[77].onLayout) cutouts[77].onLayout();
	}
	if (!cutouts[78] && cutouts.elementFactory) {
		cutouts[78] = cutouts.elementFactory(78,undefined);
	}
	if (cutouts[78]) {
		MayaAngelouCutouts_ang_sleepyhead_zzz1.call(cutouts[78] as IMayaAngelouCutouts_ang_sleepyhead_zzz1);
		cutouts[78].x = 982.5;
		cutouts[78].y = 616.5;
		if (cutouts[78].onLayout) cutouts[78].onLayout();
	}
	if (!cutouts[79] && cutouts.elementFactory) {
		cutouts[79] = cutouts.elementFactory(79,undefined);
	}
	if (cutouts[79]) {
		MayaAngelouCutouts_ang_smart1.call(cutouts[79] as IMayaAngelouCutouts_ang_smart1);
		cutouts[79].x = 496;
		cutouts[79].y = 350.5;
		if (cutouts[79].onLayout) cutouts[79].onLayout();
	}
	if (!cutouts[80] && cutouts.elementFactory) {
		cutouts[80] = cutouts.elementFactory(80,undefined);
	}
	if (cutouts[80]) {
		MayaAngelouCutouts_ang_smart_drz1.call(cutouts[80] as IMayaAngelouCutouts_ang_smart_drz1);
		cutouts[80].x = 919;
		cutouts[80].y = 653.5;
		if (cutouts[80].onLayout) cutouts[80].onLayout();
	}
	if (!cutouts[81] && cutouts.elementFactory) {
		cutouts[81] = cutouts.elementFactory(81,undefined);
	}
	if (cutouts[81]) {
		MayaAngelouCutouts_ang_spoon1.call(cutouts[81] as IMayaAngelouCutouts_ang_spoon1);
		cutouts[81].x = 630;
		cutouts[81].y = 541.5;
		if (cutouts[81].onLayout) cutouts[81].onLayout();
	}
	if (!cutouts[82] && cutouts.elementFactory) {
		cutouts[82] = cutouts.elementFactory(82,undefined);
	}
	if (cutouts[82]) {
		MayaAngelouCutouts_ang_spoon_drz1.call(cutouts[82] as IMayaAngelouCutouts_ang_spoon_drz1);
		cutouts[82].x = 826.5;
		cutouts[82].y = 582.5;
		if (cutouts[82].onLayout) cutouts[82].onLayout();
	}
	if (!cutouts[83] && cutouts.elementFactory) {
		cutouts[83] = cutouts.elementFactory(83,undefined);
	}
	if (cutouts[83]) {
		MayaAngelouCutouts_ang_springs_butterflies_11.call(cutouts[83] as IMayaAngelouCutouts_ang_springs_butterflies_11);
		cutouts[83].x = 855.5;
		cutouts[83].y = 607.5;
		if (cutouts[83].onLayout) cutouts[83].onLayout();
	}
	if (!cutouts[84] && cutouts.elementFactory) {
		cutouts[84] = cutouts.elementFactory(84,undefined);
	}
	if (cutouts[84]) {
		MayaAngelouCutouts_ang_springs_butterflies_21.call(cutouts[84] as IMayaAngelouCutouts_ang_springs_butterflies_21);
		cutouts[84].x = 799;
		cutouts[84].y = 602.5;
		if (cutouts[84].onLayout) cutouts[84].onLayout();
	}
	if (!cutouts[85] && cutouts.elementFactory) {
		cutouts[85] = cutouts.elementFactory(85,undefined);
	}
	if (cutouts[85]) {
		MayaAngelouCutouts_ang_springs_drz1.call(cutouts[85] as IMayaAngelouCutouts_ang_springs_drz1);
		cutouts[85].x = 760.5;
		cutouts[85].y = 496;
		if (cutouts[85].onLayout) cutouts[85].onLayout();
	}
	if (!cutouts[86] && cutouts.elementFactory) {
		cutouts[86] = cutouts.elementFactory(86,undefined);
	}
	if (cutouts[86]) {
		MayaAngelouCutouts_ang_springs_duck_left1.call(cutouts[86] as IMayaAngelouCutouts_ang_springs_duck_left1);
		cutouts[86].x = 858.5;
		cutouts[86].y = 573;
		if (cutouts[86].onLayout) cutouts[86].onLayout();
	}
	if (!cutouts[87] && cutouts.elementFactory) {
		cutouts[87] = cutouts.elementFactory(87,undefined);
	}
	if (cutouts[87]) {
		MayaAngelouCutouts_ang_springs_duck_right1.call(cutouts[87] as IMayaAngelouCutouts_ang_springs_duck_right1);
		cutouts[87].x = 843.5;
		cutouts[87].y = 555;
		if (cutouts[87].onLayout) cutouts[87].onLayout();
	}
	if (!cutouts[88] && cutouts.elementFactory) {
		cutouts[88] = cutouts.elementFactory(88,undefined);
	}
	if (cutouts[88]) {
		MayaAngelouCutouts_ang_springs_spring1.call(cutouts[88] as IMayaAngelouCutouts_ang_springs_spring1);
		cutouts[88].x = 970;
		cutouts[88].y = 677.5;
		if (cutouts[88].onLayout) cutouts[88].onLayout();
	}
	if (!cutouts[89] && cutouts.elementFactory) {
		cutouts[89] = cutouts.elementFactory(89,undefined);
	}
	if (cutouts[89]) {
		MayaAngelouCutouts_ang_swing_bg1.call(cutouts[89] as IMayaAngelouCutouts_ang_swing_bg1);
		cutouts[89].x = 158;
		cutouts[89].y = 274;
		if (cutouts[89].onLayout) cutouts[89].onLayout();
	}
	if (!cutouts[90] && cutouts.elementFactory) {
		cutouts[90] = cutouts.elementFactory(90,undefined);
	}
	if (cutouts[90]) {
		MayaAngelouCutouts_ang_swing_drz1.call(cutouts[90] as IMayaAngelouCutouts_ang_swing_drz1);
		cutouts[90].x = 737.5;
		cutouts[90].y = 368;
		if (cutouts[90].onLayout) cutouts[90].onLayout();
	}
	if (!cutouts[91] && cutouts.elementFactory) {
		cutouts[91] = cutouts.elementFactory(91,undefined);
	}
	if (cutouts[91]) {
		MayaAngelouCutouts_ang_teaset1.call(cutouts[91] as IMayaAngelouCutouts_ang_teaset1);
		cutouts[91].x = 727.5;
		cutouts[91].y = 654.5;
		if (cutouts[91].onLayout) cutouts[91].onLayout();
	}
	if (!cutouts[92] && cutouts.elementFactory) {
		cutouts[92] = cutouts.elementFactory(92,undefined);
	}
	if (cutouts[92]) {
		MayaAngelouCutouts_ang_turtle_drz1.call(cutouts[92] as IMayaAngelouCutouts_ang_turtle_drz1);
		cutouts[92].x = 710.5;
		cutouts[92].y = 474;
		if (cutouts[92].onLayout) cutouts[92].onLayout();
	}
	if (!cutouts[93] && cutouts.elementFactory) {
		cutouts[93] = cutouts.elementFactory(93,undefined);
	}
	if (cutouts[93]) {
		MayaAngelouCutouts_ang_turtle_left1.call(cutouts[93] as IMayaAngelouCutouts_ang_turtle_left1);
		cutouts[93].x = 833;
		cutouts[93].y = 440.5;
		if (cutouts[93].onLayout) cutouts[93].onLayout();
	}
	if (!cutouts[94] && cutouts.elementFactory) {
		cutouts[94] = cutouts.elementFactory(94,undefined);
	}
	if (cutouts[94]) {
		MayaAngelouCutouts_ang_turtle_right1.call(cutouts[94] as IMayaAngelouCutouts_ang_turtle_right1);
		cutouts[94].x = 741;
		cutouts[94].y = 268.5;
		if (cutouts[94].onLayout) cutouts[94].onLayout();
	}
	if (!cutouts[95] && cutouts.elementFactory) {
		cutouts[95] = cutouts.elementFactory(95,undefined);
	}
	if (cutouts[95]) {
		MayaAngelouCutouts_ang_tutletastic_brad1.call(cutouts[95] as IMayaAngelouCutouts_ang_tutletastic_brad1);
		cutouts[95].x = 822.5;
		cutouts[95].y = 495.5;
		if (cutouts[95].onLayout) cutouts[95].onLayout();
	}
	if (!cutouts[96] && cutouts.elementFactory) {
		cutouts[96] = cutouts.elementFactory(96,undefined);
	}
	if (cutouts[96]) {
		MayaAngelouCutouts_ang_tutletastic_drz1.call(cutouts[96] as IMayaAngelouCutouts_ang_tutletastic_drz1);
		cutouts[96].x = 854.5;
		cutouts[96].y = 555;
		if (cutouts[96].onLayout) cutouts[96].onLayout();
	}
	if (!cutouts[97] && cutouts.elementFactory) {
		cutouts[97] = cutouts.elementFactory(97,undefined);
	}
	if (cutouts[97]) {
		MayaAngelouCutouts_ang_tutletastic_xavier1.call(cutouts[97] as IMayaAngelouCutouts_ang_tutletastic_xavier1);
		cutouts[97].x = 767;
		cutouts[97].y = 456;
		if (cutouts[97].onLayout) cutouts[97].onLayout();
	}
	if (!cutouts[98] && cutouts.elementFactory) {
		cutouts[98] = cutouts.elementFactory(98,undefined);
	}
	if (cutouts[98]) {
		MayaAngelouCutouts_ang_tutletastic_yadina1.call(cutouts[98] as IMayaAngelouCutouts_ang_tutletastic_yadina1);
		cutouts[98].x = 773;
		cutouts[98].y = 485;
		if (cutouts[98].onLayout) cutouts[98].onLayout();
	}
	if (!cutouts[99] && cutouts.elementFactory) {
		cutouts[99] = cutouts.elementFactory(99,undefined);
	}
	if (cutouts[99]) {
		MayaAngelouCutouts_ang_wings_cloud11.call(cutouts[99] as IMayaAngelouCutouts_ang_wings_cloud11);
		cutouts[99].x = 490.5;
		cutouts[99].y = 676.5;
		if (cutouts[99].onLayout) cutouts[99].onLayout();
	}
	if (!cutouts[100] && cutouts.elementFactory) {
		cutouts[100] = cutouts.elementFactory(100,undefined);
	}
	if (cutouts[100]) {
		MayaAngelouCutouts_ang_wings_cloud21.call(cutouts[100] as IMayaAngelouCutouts_ang_wings_cloud21);
		cutouts[100].x = 429;
		cutouts[100].y = 517.5;
		if (cutouts[100].onLayout) cutouts[100].onLayout();
	}
	if (!cutouts[101] && cutouts.elementFactory) {
		cutouts[101] = cutouts.elementFactory(101,undefined);
	}
	if (cutouts[101]) {
		MayaAngelouCutouts_ang_wings_cloud31.call(cutouts[101] as IMayaAngelouCutouts_ang_wings_cloud31);
		cutouts[101].x = 320.5;
		cutouts[101].y = 585.5;
		if (cutouts[101].onLayout) cutouts[101].onLayout();
	}
	if (!cutouts[102] && cutouts.elementFactory) {
		cutouts[102] = cutouts.elementFactory(102,undefined);
	}
	if (cutouts[102]) {
		MayaAngelouCutouts_ang_wings_drz1.call(cutouts[102] as IMayaAngelouCutouts_ang_wings_drz1);
		cutouts[102].x = 221;
		cutouts[102].y = 392.5;
		if (cutouts[102].onLayout) cutouts[102].onLayout();
	}
	return this;
}
function MayaAngelouCutouts_ang_afriend_berbie1(this: IMayaAngelouCutouts_ang_afriend_berbie1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [52.90,-11.90,108.75,-9.05,133.35,36.30,120.40,148.90,176.05,128.85,266.65,128.85,339.80,152.15,401.30,38.20,467.30,29.15,506.80,73.80,493.20,132.05,442.70,139.85,398.70,212.30,426.55,282.80,414.25,392.20,352.75,467.25,257.60,516.45,166.35,526.15,61.50,491.85,3.90,424.55,-14.85,324.25,11.05,230.35,66.70,177.95,29.10,112.00,14.45,25.75];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_afriend_berbie.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 494.00;
	sprite.height = 511.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol2(this: IMayaAngelouCutouts_Symbol2) {
	return this;
}
function MayaAngelouCutouts_ang_afriend_berbie(this: IMayaAngelouCutouts_ang_afriend_berbie) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_afriend_berbie.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_afriend_drz1(this: IMayaAngelouCutouts_ang_afriend_drz1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [260.80,98.00,310.20,127.15,346.65,37.25,407.40,-8.90,485.15,-10.50,524.80,36.45,529.70,119.90,498.10,178.20,456.00,177.40,376.60,231.65,386.35,271.35,366.10,311.00,325.60,313.45,303.70,330.45,272.15,332.90,205.75,307.80,120.70,304.55,57.50,322.35,4.90,311.00,-14.55,277.00,-3.20,230.05,13.00,219.50,0.85,179.00,97.20,103.70,181.45,81.80];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_afriend_drz.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 516.00;
	sprite.height = 316.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol3(this: IMayaAngelouCutouts_Symbol3) {
	return this;
}
function MayaAngelouCutouts_ang_afriend_drz(this: IMayaAngelouCutouts_ang_afriend_drz) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_afriend_drz.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_afriend_hearts1(this: IMayaAngelouCutouts_ang_afriend_hearts1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [93.35,-7.35,44.55,-9.35,6.40,12.70,-9.80,46.50,-16.05,93.65,-2.85,133.55,25.70,171.20,137.55,231.70,231.15,179.65,270.85,140.05,286.40,87.80,278.50,35.40,253.05,1.25,211.90,-14.65,164.75,-6.55,134.10,15.25];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_afriend_hearts.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 272.00;
	sprite.height = 217.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol100(this: IMayaAngelouCutouts_Symbol100) {
	return this;
}
function MayaAngelouCutouts_ang_afriend_hearts(this: IMayaAngelouCutouts_ang_afriend_hearts) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_afriend_heart.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_afriend_icecream1(this: IMayaAngelouCutouts_ang_afriend_icecream1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [109.50,-6.05,152.05,44.60,140.90,88.20,164.25,156.10,197.65,104.40,247.35,54.75,321.35,36.50,360.85,41.60,405.45,-10.10,446.00,-6.05,464.25,44.60,453.10,84.15,430.80,94.30,400.40,158.15,445.95,198.70,450.00,229.10,476.35,247.35,482.45,309.15,435.85,372.00,369.95,412.55,134.80,420.65,70.95,400.35,-3.05,319.30,-1.00,245.30,61.85,222.00,96.30,167.25,78.05,92.25,53.70,74.00,50.70,35.50,75.05,-2.00];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_afriend_icecream.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 467.00;
	sprite.height = 404.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol8(this: IMayaAngelouCutouts_Symbol8) {
	return this;
}
function MayaAngelouCutouts_ang_afriend_icecream(this: IMayaAngelouCutouts_ang_afriend_icecream) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_afriend_icecream.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_art1(this: IMayaAngelouCutouts_ang_art1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [362.05,-9.75,360.45,202.50,470.75,205.60,482.15,218.55,484.20,565.45,492.50,591.85,503.35,636.90,526.15,650.40,542.75,707.35,536.50,761.20,489.90,773.10,517.85,920.70,487.85,981.80,372.05,989.55,300.20,976.65,228.40,977.15,222.70,950.20,181.30,953.85,146.05,974.05,12.45,966.25,-10.85,945.00,-16.00,907.70,2.10,872.50,50.25,866.30,74.60,764.80,38.85,759.10,18.15,721.80,30.05,669.00,47.10,638.45,87.00,632.25,102.55,227.30,111.85,202.95,223.20,201.90,260.00,171.95,265.70,-10.30];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_art.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 528.00;
	sprite.height = 975.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol1(this: IMayaAngelouCutouts_Symbol1) {
	return this;
}
function MayaAngelouCutouts_ang_art(this: IMayaAngelouCutouts_ang_art) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_art.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_art_drz1(this: IMayaAngelouCutouts_ang_art_drz1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [204.05,9.15,223.35,66.00,213.20,104.55,222.35,112.70,286.65,89.90,328.30,56.15,388.80,80.20,385.45,120.30,351.55,147.60,319.80,151.25,269.05,183.75,261.90,228.35,229.80,241.10,173.75,228.35,37.45,244.20,-12.15,215.20,-10.15,161.40,24.40,147.20,24.40,114.70,78.20,80.20,85.30,22.35,117.75,-10.15,171.10,-14.45];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_art_drz.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 376.00;
	sprite.height = 229.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol9(this: IMayaAngelouCutouts_Symbol9) {
	return this;
}
function MayaAngelouCutouts_ang_art_drz(this: IMayaAngelouCutouts_ang_art_drz) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_art_drz.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_balloon1(this: IMayaAngelouCutouts_ang_balloon1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [416.15,1138.90,411.05,1108.35,419.95,1062.55,166.75,599.30,136.15,589.15,62.35,581.55,3.80,528.10,-10.15,427.55,20.35,363.95,81.05,327.05,159.05,338.50,215.05,375.40,229.70,411.55,241.80,369.00,218.90,316.85,127.70,298.80,80.20,218.90,75.15,131.10,109.50,56.00,171.85,16.55,272.35,24.20,329.65,76.35,353.80,159.10,347.45,226.30,310.55,282.10,281.30,295.25,282.55,323.25,338.55,302.90,398.35,309.25,451.80,291.45,517.10,308.10,512.90,281.25,458.15,249.45,425.05,176.90,436.55,75.10,487.45,7.65,567.70,-13.55,637.60,6.40,702.50,95.45,703.75,174.35,766.65,157.75,834.85,184.55,878.10,244.35,877.05,328.40,829.05,402.15,829.70,450.45,811.95,485.10,837.35,537.00,838.60,605.70,818.70,644.60,794.35,671.40,820.85,706.25,824.65,771.15,796.65,836.05,736.85,874.20,664.30,875.50,634.60,886.20,489.95,1062.55,499.00,1112.20,488.05,1137.75,453.05,1149.10];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_balloon.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 866.00;
	sprite.height = 1135.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol10(this: IMayaAngelouCutouts_Symbol10) {
	return this;
}
function MayaAngelouCutouts_ang_balloon(this: IMayaAngelouCutouts_ang_balloon) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_balloon.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_balloon_drz1(this: IMayaAngelouCutouts_ang_balloon_drz1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [271.25,152.50,324.45,173.00,334.70,130.00,351.05,107.50,338.00,55.70,371.50,40.95,386.45,-10.65,416.15,-10.80,436.00,21.50,459.55,33.80,459.15,82.45,494.35,128.95,502.65,179.65,489.75,218.20,459.55,229.25,428.85,284.50,440.10,321.35,429.35,351.00,392.00,369.45,357.90,416.75,294.50,406.05,253.85,408.35,209.85,369.45,143.30,353.10,90.10,378.65,60.40,432.90,31.25,436.40,-12.25,384.80,-10.20,327.50,39.65,313.80,34.75,247.05,81.10,175.25,178.80,122.65,233.50,120.20];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_balloon_drz.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 496.00;
	sprite.height = 423.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol11(this: IMayaAngelouCutouts_Symbol11) {
	return this;
}
function MayaAngelouCutouts_ang_balloon_drz(this: IMayaAngelouCutouts_ang_balloon_drz) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_balloon_drz.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_bread1(this: IMayaAngelouCutouts_ang_bread1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [69.35,189.90,25.15,186.70,-14.10,163.05,-12.90,74.50,32.85,37.15,141.85,17.95,235.75,-16.65,317.90,-7.00,335.00,21.85,578.20,80.80,578.85,159.20,338.85,265.70];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_bread.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 566.00;
	sprite.height = 250.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol12(this: IMayaAngelouCutouts_Symbol12) {
	return this;
}
function MayaAngelouCutouts_ang_bread(this: IMayaAngelouCutouts_ang_bread) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_bread.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_bread_drz1(this: IMayaAngelouCutouts_ang_bread_drz1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [226.10,12.05,249.80,42.95,263.35,87.85,257.90,126.45,308.45,155.55,342.70,194.95,342.70,232.85,381.00,240.30,400.50,279.20,388.65,323.90,362.40,333.80,337.35,355.50,297.90,357.50,239.40,335.80,192.05,345.00,124.95,332.50,50.65,351.55,5.95,343.00,-11.55,309.80,-6.55,264.75,25.00,229.25,42.10,226.60,44.70,189.20,74.95,153.70,60.50,110.95,68.45,50.20,72.90,39.45,98.90,1.60,143.50,-16.25,195.25,-6.35];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_bread_drz.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 383.00;
	sprite.height = 342.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol101(this: IMayaAngelouCutouts_Symbol101) {
	return this;
}
function MayaAngelouCutouts_ang_bread_drz(this: IMayaAngelouCutouts_ang_bread_drz) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_bread_drz.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_counterpart1(this: IMayaAngelouCutouts_ang_counterpart1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [706.75,24.90,758.65,28.50,763.15,62.75,728.50,83.35,701.25,104.30,668.25,111.40,668.35,131.45,685.35,139.20,767.55,302.85,762.85,328.95,687.25,358.05,686.00,659.80,666.60,673.15,106.75,673.70,89.85,660.75,90.80,353.90,8.80,323.40,9.10,293.15,93.35,129.25,597.30,130.35,598.75,30.20,614.65,-1.10,645.75,1.45];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_counterpart.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 757.00;
	sprite.height = 660.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol14(this: IMayaAngelouCutouts_Symbol14) {
	return this;
}
function MayaAngelouCutouts_ang_counterpart(this: IMayaAngelouCutouts_ang_counterpart) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_counterpart.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_counterpart_drz_11(this: IMayaAngelouCutouts_ang_counterpart_drz_11) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [98.60,17.55,101.80,84.85,141.05,83.80,176.05,97.05,213.75,134.05,229.05,171.25,221.35,214.15,127.30,211.30,110.30,232.75,81.15,233.80,53.75,221.55,29.70,179.40,38.20,137.85,11.70,90.70,-9.50,77.45,-11.65,35.00,14.35,-9.00,53.05,-13.75];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_counterpart_drz_1.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 213.00;
	sprite.height = 221.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol15(this: IMayaAngelouCutouts_Symbol15) {
	return this;
}
function MayaAngelouCutouts_ang_counterpart_drz_1(this: IMayaAngelouCutouts_ang_counterpart_drz_1) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_counterpart_drz_1.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_counterpart_drz_21(this: IMayaAngelouCutouts_ang_counterpart_drz_21) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [91.30,3.70,142.00,55.65,220.35,19.50,340.55,27.20,432.55,88.05,450.85,126.25,528.90,108.80,609.60,134.95,608.60,211.75,563.10,253.20,469.50,210.00,459.15,269.85,468.20,305.20,446.65,351.95,414.30,371.05,386.05,373.55,336.25,396.80,331.25,442.45,283.95,449.10,259.05,438.30,156.95,438.30,135.35,448.25,78.05,439.15,82.20,383.50,146.15,381.85,104.65,337.85,79.55,285.15,58.95,252.35,59.80,197.15,73.10,180.10,69.75,159.40,88.00,127.85,0.00,111.25,-8.60,25.75,29.95,-14.90];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_counterpart_drz_2.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 598.00;
	sprite.height = 434.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol16(this: IMayaAngelouCutouts_Symbol16) {
	return this;
}
function MayaAngelouCutouts_ang_counterpart_drz_2(this: IMayaAngelouCutouts_ang_counterpart_drz_2) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_counterpart_drz_2.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_dance_stereo1(this: IMayaAngelouCutouts_ang_dance_stereo1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [393.70,-13.35,414.80,34.55,413.85,219.45,385.80,235.45,6.20,236.20,-12.25,220.15,-11.90,3.95,-0.35,-12.75];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_dance_stereo.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 401.00;
	sprite.height = 225.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol17(this: IMayaAngelouCutouts_Symbol17) {
	return this;
}
function MayaAngelouCutouts_ang_dance_stereo(this: IMayaAngelouCutouts_ang_dance_stereo) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_dance_stereo.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_flower1(this: IMayaAngelouCutouts_ang_flower1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [317.85,40.85,313.20,105.95,317.05,163.55,284.80,189.45,339.05,223.20,345.55,266.05,324.95,290.75,284.95,285.20,273.50,400.15,231.45,416.80,170.10,416.10,130.90,401.05,120.10,340.80,85.85,359.90,70.75,336.35,86.85,262.50,30.70,262.15,-8.60,243.60,-8.45,216.00,44.85,174.00,78.55,146.00,55.90,119.40,62.05,83.40,79.35,54.75,124.75,44.05,136.85,14.75,196.10,4.05,218.70,-14.65,261.10,-8.85,278.15,24.05];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_flower.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 332.00;
	sprite.height = 403.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol18(this: IMayaAngelouCutouts_Symbol18) {
	return this;
}
function MayaAngelouCutouts_ang_flower(this: IMayaAngelouCutouts_ang_flower) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_flower.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_flower_drz1(this: IMayaAngelouCutouts_ang_flower_drz1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [410.65,76.40,397.25,131.90,367.90,141.00,322.00,217.85,366.30,230.10,378.60,264.80,352.95,319.80,320.40,325.15,270.75,304.85,252.60,312.35,250.95,349.70,217.35,384.40,181.05,386.05,140.45,340.65,82.25,338.50,33.05,311.40,15.85,278.35,-13.85,248.80,-10.65,209.85,16.55,182.60,57.70,189.00,103.05,157.50,157.55,141.50,181.35,119.95,219.45,122.30,238.65,143.65,236.00,76.90,246.95,31.55,286.15,-7.50,335.40,-14.95,381.80,12.30];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_flower_drz.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 393.00;
	sprite.height = 373.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol19(this: IMayaAngelouCutouts_Symbol19) {
	return this;
}
function MayaAngelouCutouts_ang_flower_drz(this: IMayaAngelouCutouts_ang_flower_drz) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_flower_drz.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_flower_left1(this: IMayaAngelouCutouts_ang_flower_left1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [199.60,-9.15,223.95,53.45,215.45,86.05,239.65,86.85,275.15,106.90,280.55,204.55,327.35,84.90,361.55,74.35,359.45,101.65,323.55,207.35,356.70,189.35,379.40,188.00,384.90,196.25,426.85,180.30,453.50,179.25,450.05,204.55,394.95,243.80,489.60,238.65,498.25,267.25,418.30,292.15,475.05,312.20,485.90,328.90,554.35,330.55,555.20,365.60,545.20,384.00,543.50,472.50,564.20,502.40,561.85,540.95,545.15,558.50,533.50,607.75,507.60,627.75,455.00,633.60,399.90,631.10,356.35,605.60,301.40,632.80,111.15,590.25,107.70,538.45,86.00,525.10,74.85,448.00,48.45,449.10,33.40,429.05,37.60,395.70,74.30,370.65,63.50,343.95,9.80,358.90,8.25,333.25,43.75,306.05,-6.65,314.75,-6.20,289.95,56.40,241.15,58.35,213.75,73.50,194.50,76.00,161.95,125.05,167.55,91.25,119.35,90.75,75.35,113.60,63.40,113.55,26.75,129.00,-6.45];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_flower_left.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 551.00;
	sprite.height = 620.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol20(this: IMayaAngelouCutouts_Symbol20) {
	return this;
}
function MayaAngelouCutouts_ang_flower_left(this: IMayaAngelouCutouts_ang_flower_left) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_flower_left.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_flower_right1(this: IMayaAngelouCutouts_ang_flower_right1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [189.80,2.70,200.50,78.50,223.30,92.55,228.00,133.50,205.20,176.35,183.75,191.80,197.20,211.90,218.60,193.15,244.75,198.50,246.80,217.25,291.70,238.75,309.85,221.95,352.05,246.80,319.85,142.85,317.85,114.70,350.05,117.35,398.30,244.75,400.30,140.85,431.85,138.15,456.00,237.40,514.30,176.40,543.80,175.05,538.40,203.85,492.85,270.90,551.15,251.45,605.45,264.80,678.55,321.80,685.25,352.65,656.45,345.90,574.60,303.05,529.70,310.40,646.35,352.00,676.55,388.20,659.75,392.20,588.05,365.40,520.30,359.35,603.45,384.20,607.45,404.95,526.35,405.65,586.70,429.80,585.30,484.05,577.25,494.80,568.55,628.90,380.15,671.15,347.95,657.05,343.25,700.00,318.45,720.10,269.50,728.80,195.75,722.80,168.25,696.65,160.90,642.30,126.75,638.35,105.95,622.90,101.25,580.65,73.80,593.30,59.70,570.60,70.40,512.95,24.80,510.95,-8.00,492.85,-7.35,467.35,42.90,431.15,33.55,403.00,39.60,377.50,48.30,368.10,53.65,348.00,24.15,331.90,22.80,301.05,68.40,278.95,45.60,268.85,46.95,240.70,87.85,227.95,42.25,217.25,20.15,172.30,24.85,132.80,51.65,106.65,96.60,105.30,72.45,91.20,77.80,40.95,109.30,-14.05];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_flower_right.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 679.00;
	sprite.height = 737.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol21(this: IMayaAngelouCutouts_Symbol21) {
	return this;
}
function MayaAngelouCutouts_ang_flower_right(this: IMayaAngelouCutouts_ang_flower_right) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_flower_right.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_heart_11(this: IMayaAngelouCutouts_ang_heart_11) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [466.40,-0.20,583.95,-21.65,698.40,26.65,755.75,145.45,753.70,299.05,677.90,419.90,532.50,516.10,372.75,604.20,186.35,510.00,55.30,409.65,-14.35,276.50,-12.30,127.00,65.55,16.40,178.20,-22.50,280.60,2.10,370.00,66.20];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_heart_1.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 742.00;
	sprite.height = 585.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol22(this: IMayaAngelouCutouts_Symbol22) {
	return this;
}
function MayaAngelouCutouts_ang_heart_1(this: IMayaAngelouCutouts_ang_heart_1) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_heart_1.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_heart_21(this: IMayaAngelouCutouts_ang_heart_21) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [331.05,27.35,420.40,45.20,465.60,110.35,470.85,208.15,428.80,290.05,354.20,340.50,180.80,398.30,37.85,275.35,-9.45,195.50,-15.75,105.10,28.40,13.65,99.85,-14.70,182.90,-2.10,248.05,55.70];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_heart_2.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 455.00;
	sprite.height = 380.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol23(this: IMayaAngelouCutouts_Symbol23) {
	return this;
}
function MayaAngelouCutouts_ang_heart_2(this: IMayaAngelouCutouts_ang_heart_2) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_heart_2.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_heart_31(this: IMayaAngelouCutouts_ang_heart_31) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [182.35,13.50,246.90,-16.80,310.85,-2.00,368.00,61.25,380.10,137.25,358.60,203.20,265.75,328.20,128.55,319.50,47.80,295.30,0.05,242.15,-16.10,170.15,-0.65,107.70,48.45,71.35,97.20,62.20,144.85,72.10];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_heart_3.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 363.00;
	sprite.height = 315.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol24(this: IMayaAngelouCutouts_Symbol24) {
	return this;
}
function MayaAngelouCutouts_ang_heart_3(this: IMayaAngelouCutouts_ang_heart_3) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_heart_3.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_heart_drz1(this: IMayaAngelouCutouts_ang_heart_drz1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [151.50,-7.35,193.75,32.85,191.45,69.45,225.15,91.55,248.30,129.40,268.25,153.60,263.80,189.15,230.40,196.75,249.35,236.70,236.70,273.55,204.10,286.15,169.40,279.85,153.60,238.80,133.90,239.85,124.50,275.70,105.50,288.00,56.05,287.20,43.15,256.70,45.25,222.00,-2.70,224.35,-12.60,194.65,-7.95,166.25,15.30,156.30,25.25,115.75,53.65,86.30,57.90,45.25,74.70,3.20,113.75,-16.80];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_heart_drz.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 255.00;
	sprite.height = 277.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol25(this: IMayaAngelouCutouts_Symbol25) {
	return this;
}
function MayaAngelouCutouts_ang_heart_drz(this: IMayaAngelouCutouts_ang_heart_drz) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_heart_drz.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_heart_drz_front1(this: IMayaAngelouCutouts_ang_heart_drz_front1) {
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_heart_drz_front.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 180.00;
	sprite.height = 106.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_ang_heart_drz_front(this: IMayaAngelouCutouts_ang_heart_drz_front) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_heart_drz_front.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_lovedaton1(this: IMayaAngelouCutouts_ang_lovedaton1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [612.55,97.20,655.70,181.55,756.15,157.80,814.25,172.15,824.80,237.65,784.65,318.95,672.15,287.85,654.75,296.65,675.10,335.60,662.15,389.70,624.10,425.60,598.10,431.95,522.40,495.90,530.70,554.75,493.00,585.35,456.30,582.45,453.05,639.95,468.90,715.95,487.90,747.65,549.25,762.25,557.60,801.50,550.20,840.90,499.50,863.80,387.35,852.70,353.20,837.95,339.00,812.05,303.10,845.85,219.65,871.15,135.20,868.00,106.80,832.20,110.15,782.70,152.90,758.75,190.10,760.30,218.55,692.30,219.10,668.10,230.25,638.85,234.50,562.85,234.35,508.50,248.20,456.20,203.90,422.10,171.25,379.40,152.10,332.60,116.25,329.15,87.90,292.95,77.10,238.65,83.85,194.10,120.40,173.15,153.15,168.95,139.75,152.50,2.40,141.75,-17.90,60.25,16.95,-14.75,110.60,-7.60,185.90,39.10,208.60,69.75,275.25,20.95,382.55,0.20,469.95,12.70,546.35,44.35];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_lovedaton.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 808.00;
	sprite.height = 858.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol26(this: IMayaAngelouCutouts_Symbol26) {
	return this;
}
function MayaAngelouCutouts_ang_lovedaton(this: IMayaAngelouCutouts_ang_lovedaton) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_lovedaton.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_lovedaton_heart11(this: IMayaAngelouCutouts_ang_lovedaton_heart11) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [146.50,-10.90,170.95,17.00,177.55,61.55,160.75,102.45,100.30,148.55,16.30,123.45,-8.10,92.95,-12.85,57.00,-5.20,20.00,32.60,3.40,72.00,7.50,102.45,-12.85];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_lovedaton_heart1.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 163.00;
	sprite.height = 136.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol27(this: IMayaAngelouCutouts_Symbol27) {
	return this;
}
function MayaAngelouCutouts_ang_lovedaton_heart1(this: IMayaAngelouCutouts_ang_lovedaton_heart1) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_lovedaton_heart1.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_lovedaton_heart21(this: IMayaAngelouCutouts_ang_lovedaton_heart21) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [75.20,9.80,110.65,15.65,129.35,35.60,128.50,71.40,107.20,102.00,71.60,112.30,28.15,113.05,-10.20,61.55,-10.60,18.50,12.15,-9.10,51.00,-10.70];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_lovedaton_heart2.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 117.00;
	sprite.height = 102.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol28(this: IMayaAngelouCutouts_Symbol28) {
	return this;
}
function MayaAngelouCutouts_ang_lovedaton_heart2(this: IMayaAngelouCutouts_ang_lovedaton_heart2) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_lovedaton_heart2.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_lovedaton_heart31(this: IMayaAngelouCutouts_ang_lovedaton_heart31) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [79.40,-5.40,111.00,-14.85,142.55,-4.55,167.25,33.15,164.20,80.10,144.55,113.95,115.30,146.20,56.30,145.25,8.80,128.20,-13.55,89.60,-9.50,43.45,16.30,22.50,56.30,19.05];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_lovedaton_heart3.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 155.00;
	sprite.height = 135.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol29(this: IMayaAngelouCutouts_Symbol29) {
	return this;
}
function MayaAngelouCutouts_ang_lovedaton_heart3(this: IMayaAngelouCutouts_ang_lovedaton_heart3) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_lovedaton_heart3.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_lovedaton_heart41(this: IMayaAngelouCutouts_ang_lovedaton_heart41) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [178.55,16.35,226.05,23.10,254.95,56.20,262.70,103.90,244.55,158.75,209.60,186.35,150.70,208.40,89.20,220.40,38.80,177.65,-7.40,120.15,-14.90,66.55,7.10,11.45,51.65,-14.20,96.40,-9.15,122.90,6.80,139.20,27.85];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_lovedaton_heart4.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 247.00;
	sprite.height = 208.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol30(this: IMayaAngelouCutouts_Symbol30) {
	return this;
}
function MayaAngelouCutouts_ang_lovedaton_heart4(this: IMayaAngelouCutouts_ang_lovedaton_heart4) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_lovedaton_heart4.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_marshmallowsbg1(this: IMayaAngelouCutouts_ang_marshmallowsbg1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [282.55,16.32,277.27,51.46,282.00,62.93,280.89,166.85,239.96,181.13,196.77,182.79,150.31,193.70,85.75,189.88,72.08,176.76,30.29,179.47,-10.89,170.92,-13.45,55.33,13.55,36.23,48.55,32.91,109.84,41.66,117.73,9.28,141.56,3.90,162.83,-8.47,206.27,-10.08,235.49,-14.30];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_marshmallowsbg.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 271.00;
	sprite.height = 179.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol31(this: IMayaAngelouCutouts_Symbol31) {
	return this;
}
function MayaAngelouCutouts_ang_marshmallowsbg(this: IMayaAngelouCutouts_ang_marshmallowsbg) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_marshmallowsbg.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_moon1(this: IMayaAngelouCutouts_ang_moon1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [472.15,13.35,578.55,96.45,646.75,224.50,658.25,355.95,627.80,472.20,563.55,563.40,453.90,633.45,317.55,661.70,167.95,625.15,43.85,526.05,-13.15,390.25,-18.25,261.95,38.25,128.05,126.35,38.30,246.05,-11.60,342.50,-16.60];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_moon.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 641.00;
	sprite.height = 641.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol33(this: IMayaAngelouCutouts_Symbol33) {
	return this;
}
function MayaAngelouCutouts_ang_moon(this: IMayaAngelouCutouts_ang_moon) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_moon.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_moon_drz1(this: IMayaAngelouCutouts_ang_moon_drz1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [180.50,100.05,186.60,53.75,204.10,30.60,218.95,22.70,247.75,47.20,253.10,70.00,267.60,92.75,266.65,126.55,246.00,146.40,242.10,187.85,226.80,197.90,208.25,220.20,175.30,218.00,148.30,219.30,82.20,235.90,58.60,233.70,39.75,207.05,42.15,178.70,59.05,171.70,60.80,143.80,79.15,108.85,108.85,92.65,137.55,81.70];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_moon_drz.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 310.00;
	sprite.height = 279.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol34(this: IMayaAngelouCutouts_Symbol34) {
	return this;
}
function MayaAngelouCutouts_ang_moon_drz(this: IMayaAngelouCutouts_ang_moon_drz) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_moon_drz.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_moon_drz_front1(this: IMayaAngelouCutouts_ang_moon_drz_front1) {
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_moon_drz_front.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 310.00;
	sprite.height = 279.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_ang_moon_drz_front(this: IMayaAngelouCutouts_ang_moon_drz_front) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_moon_drz_front.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_numberone1(this: IMayaAngelouCutouts_ang_numberone1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [337.40,1.75,411.00,-4.25,516.35,34.30,572.00,95.10,616.55,186.70,621.65,232.95,649.90,244.90,744.95,274.90,786.90,313.45,764.65,367.30,779.20,414.35,771.50,446.05,749.25,456.35,739.80,550.50,744.95,575.35,772.35,608.75,764.65,661.85,739.80,692.65,702.15,696.10,667.00,682.40,645.65,642.10,625.05,679.80,602.80,689.25,610.55,751.70,655.05,756.85,685.85,785.15,682.45,838.20,643.90,861.35,560.00,864.75,492.35,848.50,469.25,816.80,440.10,848.50,387.05,869.90,283.45,874.15,244.05,840.80,248.30,783.40,307.40,761.15,315.10,733.75,350.20,722.60,368.15,661.80,359.65,579.65,284.35,543.70,254.35,508.55,218.40,491.45,187.55,506.85,136.20,492.30,125.90,513.70,41.10,517.10,-15.35,463.20,-3.40,399.85,44.55,329.60,98.50,305.65,113.90,280.85,113.05,192.65,143.00,119.05,199.50,57.40,257.75,27.45,275.70,-23.20];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_numberone.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 767.00;
	sprite.height = 859.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol35(this: IMayaAngelouCutouts_Symbol35) {
	return this;
}
function MayaAngelouCutouts_ang_numberone(this: IMayaAngelouCutouts_ang_numberone) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_numberone.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_onionrings1(this: IMayaAngelouCutouts_ang_onionrings1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [195.00,-12.50,215.95,1.40,351.45,1.40,493.60,28.20,576.75,60.40,605.40,97.95,598.25,135.50,582.00,154.15,658.45,143.45,758.45,152.80,784.30,183.55,779.35,222.60,693.05,248.40,583.15,229.75,536.40,235.80,489.70,269.30,433.10,284.70,380.30,277.00,344.05,250.60,332.50,221.50,216.15,219.75,129.75,205.65,80.80,179.80,10.90,150.50,-14.30,122.10,-10.20,74.25,22.55,48.95,49.15,15.10,111.75,-10.75];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_onionrings.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 772.00;
	sprite.height = 266.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol36(this: IMayaAngelouCutouts_Symbol36) {
	return this;
}
function MayaAngelouCutouts_ang_onionrings(this: IMayaAngelouCutouts_ang_onionrings) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_onionrings.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_onionrings_drz1(this: IMayaAngelouCutouts_ang_onionrings_drz1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [75.40,-17.20,126.00,-4.25,171.25,29.10,206.90,132.50,282.15,113.10,360.75,123.90,418.75,157.25,480.05,222.70,488.90,254.20,513.75,276.75,515.30,330.90,493.25,358.10,452.45,360.30,396.80,337.20,332.25,346.25,266.00,340.35,235.60,359.10,191.05,371.80,143.85,348.70,128.15,300.50,107.70,273.10,112.00,217.55,66.10,175.60,32.80,182.05,6.90,169.25,-14.00,116.30,-15.15,46.55,14.75,-1.40];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_onionrings_drz.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 502.00;
	sprite.height = 354.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol37(this: IMayaAngelouCutouts_Symbol37) {
	return this;
}
function MayaAngelouCutouts_ang_onionrings_drz(this: IMayaAngelouCutouts_ang_onionrings_drz) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_onionrings_drz.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_pie1(this: IMayaAngelouCutouts_ang_pie1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [-9.45,168.70,11.10,160.05,0.30,128.70,12.95,105.80,65.15,82.30,75.40,58.45,118.15,46.55,125.15,25.20,188.25,12.40,244.10,23.70,252.55,36.20,353.80,38.95,366.80,26.00,442.45,35.70,447.85,59.50,477.05,69.25,497.60,-6.45,551.50,-10.30,592.35,16.80,574.85,101.05,595.95,120.75,595.70,150.95,582.45,166.10,616.80,188.60,599.75,255.35,578.25,257.40,567.90,287.85,516.25,291.85,479.55,286.45,469.60,304.45,412.20,308.20,365.80,319.85,306.40,319.00,290.40,305.15,203.20,297.55,152.05,309.35,115.10,307.95,97.95,295.75,30.15,285.90,26.35,257.90,-5.40,256.30,-10.95,237.55,-14.40,207.25];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_pie.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 604.00;
	sprite.height = 307.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol38(this: IMayaAngelouCutouts_Symbol38) {
	return this;
}
function MayaAngelouCutouts_ang_pie(this: IMayaAngelouCutouts_ang_pie) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_pie.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_marshmallows11(this: IMayaAngelouCutouts_ang_marshmallows11) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [56.10,29.15,60.45,-3.00,118.35,-17.55,185.50,0.65,193.75,21.20,207.40,22.55,244.70,35.55,241.30,82.90,233.35,132.10,181.90,136.35,161.00,148.05,116.85,149.50,94.10,162.50,19.25,170.95,-7.50,157.25,-13.65,43.10];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_marshmallows1.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 232.00;
	sprite.height = 155.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol103(this: IMayaAngelouCutouts_Symbol103) {
	return this;
}
function MayaAngelouCutouts_ang_marshmallows1(this: IMayaAngelouCutouts_ang_marshmallows1) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_marshmallows1.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_marshmallows21(this: IMayaAngelouCutouts_ang_marshmallows21) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [26.05,-1.50,64.25,-2.90,103.85,-16.80,194.85,2.60,194.15,54.05,242.75,63.10,244.15,160.30,189.95,172.85,142.75,168.65,135.10,149.90,87.20,147.85,50.35,136.05,-6.60,131.85,-14.20,17.95];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_marshmallows2.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 233.00;
	sprite.height = 159.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol40(this: IMayaAngelouCutouts_Symbol40) {
	return this;
}
function MayaAngelouCutouts_ang_marshmallows2(this: IMayaAngelouCutouts_ang_marshmallows2) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_marshmallows2.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_marshmallows31(this: IMayaAngelouCutouts_ang_marshmallows31) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [32.20,-12.85,74.00,-1.15,91.70,-14.20,155.95,-9.85,162.00,4.90,196.95,11.65,201.95,41.40,271.20,32.55,326.25,50.25,321.75,166.35,287.90,177.65,237.55,180.25,202.65,190.85,137.40,194.50,106.95,183.20,34.30,177.45,29.35,92.80,-10.70,83.90,-14.20,-0.45];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_marshmallows3.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 312.00;
	sprite.height = 179.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol39(this: IMayaAngelouCutouts_Symbol39) {
	return this;
}
function MayaAngelouCutouts_ang_marshmallows3(this: IMayaAngelouCutouts_ang_marshmallows3) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_marshmallows3.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_pie_drz1(this: IMayaAngelouCutouts_ang_pie_drz1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [151.70,-7.10,185.70,44.65,183.65,86.30,225.85,113.65,233.35,155.70,264.40,176.10,264.05,219.70,221.70,246.65,192.40,245.30,154.30,230.35,116.75,233.50,76.10,221.65,28.30,233.60,-9.55,221.30,-9.75,170.60,26.85,138.85,30.25,113.00,48.95,93.45,48.95,34.75,82.75,-11.85];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_pie_drz.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 253.00;
	sprite.height = 234.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol41(this: IMayaAngelouCutouts_Symbol41) {
	return this;
}
function MayaAngelouCutouts_ang_pie_drz(this: IMayaAngelouCutouts_ang_pie_drz) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_pie_drz.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_pillow1(this: IMayaAngelouCutouts_ang_pillow1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [93.25,-2.65,166.90,20.95,260.60,-2.60,407.00,-16.55,542.85,-8.70,624.35,11.05,683.55,-2.40,750.60,4.85,753.65,37.05,722.80,103.65,737.30,270.10,776.50,330.25,786.10,391.25,832.25,424.40,834.90,466.15,780.00,486.25,680.60,480.15,590.05,508.05,456.65,532.45,337.25,530.70,228.35,515.90,172.55,499.30,24.40,513.30,-13.00,502.80,-9.55,462.75,24.40,434.00,27.95,356.40,52.30,273.65,40.10,200.45,61.05,111.55,24.45,60.70,35.85,13.95];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_pillow.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 823.00;
	sprite.height = 518.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol42(this: IMayaAngelouCutouts_Symbol42) {
	return this;
}
function MayaAngelouCutouts_ang_pillow(this: IMayaAngelouCutouts_ang_pillow) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_pillow.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_pillow_drz1(this: IMayaAngelouCutouts_ang_pillow_drz1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [36.10,21.90,95.85,25.15,175.90,81.95,226.15,71.05,226.40,6.35,270.90,-14.15,316.90,1.70,325.10,45.80,314.60,76.50,365.95,100.55,392.30,119.30,473.10,123.10,495.15,175.65,474.10,236.00,424.20,230.25,380.70,310.90,381.60,359.55,351.25,389.30,319.45,393.55,260.45,387.30,246.90,348.45,188.40,285.85,154.30,315.60,109.35,315.70,78.70,276.35,83.05,222.85,130.35,207.70,126.80,183.50,42.90,164.75,0.95,132.20,-14.75,89.95,-7.70,46.25];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_pillow_drz.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 479.00;
	sprite.height = 381.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol43(this: IMayaAngelouCutouts_Symbol43) {
	return this;
}
function MayaAngelouCutouts_ang_pillow_drz(this: IMayaAngelouCutouts_ang_pillow_drz) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_pillow_drz.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_pizzatower1(this: IMayaAngelouCutouts_ang_pizzatower1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [604.65,-3.75,700.80,-15.00,796.70,-8.00,860.70,13.30,863.85,47.45,827.55,60.80,829.25,102.90,822.95,148.80,825.50,176.60,818.20,215.00,834.05,332.65,821.85,343.15,828.60,382.45,848.20,433.45,862.85,455.30,863.75,488.90,843.85,501.25,870.85,535.60,888.60,536.85,900.00,558.35,907.00,573.50,901.15,600.65,876.70,605.75,825.85,605.90,791.50,613.70,611.90,672.65,580.85,672.70,563.40,656.10,556.30,633.80,540.05,635.45,370.75,675.75,337.70,674.10,334.20,648.80,304.00,646.70,287.10,660.05,257.65,661.50,241.50,672.00,114.45,677.60,9.85,670.60,-14.00,636.90,-6.30,602.50,-9.10,556.80,-12.55,525.30,31.60,506.35,111.65,499.30,167.80,505.60,172.70,481.75,190.95,466.30,192.35,432.65,183.95,395.45,167.15,386.35,171.30,349.10,305.40,325.95,391.00,330.85,377.70,274.70,346.10,270.50,333.45,254.35,335.55,229.75,397.30,204.50,498.40,193.25,551.75,198.90,546.85,166.60,553.90,131.50,562.20,110.25,557.20,67.65,534.45,48.30,536.45,18.60];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_pizzatower.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 895.00;
	sprite.height = 663.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol105(this: IMayaAngelouCutouts_Symbol105) {
	return this;
}
function MayaAngelouCutouts_ang_pizzatower(this: IMayaAngelouCutouts_ang_pizzatower) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_pizzatower_left.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_pizzatower2(this: IMayaAngelouCutouts_ang_pizzatower2) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [95.40,-4.90,235.65,-14.10,395.15,17.60,400.75,51.30,374.80,73.75,369.85,127.80,386.70,181.15,384.30,200.70,374.15,215.50,380.45,222.50,448.55,218.30,544.00,226.70,624.05,257.65,619.80,292.70,571.40,305.35,561.55,369.20,657.05,362.90,801.60,393.05,807.95,424.65,791.10,441.50,779.15,497.65,786.15,522.20,810.00,563.65,882.35,553.80,965.90,564.35,1006.60,588.25,1008.00,617.70,999.55,629.65,999.55,672.45,1006.60,709.65,988.35,741.95,848.65,751.10,726.50,744.05,707.55,734.25,670.40,731.45,659.80,720.90,623.30,720.20,620.50,745.45,588.25,750.40,400.10,704.75,377.60,702.65,362.90,738.45,336.90,746.85,303.90,740.55,136.15,685.10,105.60,675.75,89.10,672.50,14.70,670.40,-5.65,663.35,-15.15,646.70,-11.15,627.35,-1.75,621.10,3.30,610.75,13.40,599.95,28.65,593.60,57.85,559.90,30.30,535.70,39.25,493.85,54.20,476.50,80.70,390.25,68.65,360.60,84.35,237.05,78.60,183.10,80.05,143.20,75.15,112.35,80.05,73.75,40.75,54.05,37.15,19.70];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_pizzatower11.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 994.00;
	sprite.height = 736.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol104(this: IMayaAngelouCutouts_Symbol104) {
	return this;
}
function MayaAngelouCutouts_ang_pizzatower11(this: IMayaAngelouCutouts_ang_pizzatower11) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_pizzatower_right.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_pizzatower__xavier1(this: IMayaAngelouCutouts_ang_pizzatower__xavier1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [44.25,23.25,54.90,56.30,68.95,64.75,162.50,36.60,153.40,18.30,164.65,-11.20,202.55,-15.15,213.15,9.90,239.20,6.15,277.10,43.80,284.20,103.45,305.40,196.70,287.65,256.10,262.40,277.85,290.35,326.15,282.80,362.25,250.05,371.60,255.40,429.80,275.40,436.00,279.30,452.30,313.20,468.00,311.60,507.75,282.10,522.65,237.10,525.45,190.65,514.20,157.60,521.25,101.30,515.60,85.85,495.20,90.05,460.75,116.10,450.20,127.35,432.65,123.10,394.65,100.70,377.30,94.45,342.05,108.35,311.65,63.35,291.25,41.55,290.55,12.55,247.20,11.30,191.35,8.05,146.80,22.50,105.55,16.90,87.25,-9.45,77.25,-14.05,49.25,2.55,25.25];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_pizzatower__xavier.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 301.00;
	sprite.height = 511.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol45(this: IMayaAngelouCutouts_Symbol45) {
	return this;
}
function MayaAngelouCutouts_ang_pizzatower__xavier(this: IMayaAngelouCutouts_ang_pizzatower__xavier) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_pizzatower__xavier.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_pizzatower_brad1(this: IMayaAngelouCutouts_ang_pizzatower_brad1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [224.50,0.45,295.05,55.10,310.45,128.85,299.15,194.75,261.05,248.15,219.20,272.30,255.10,401.25,234.50,439.15,232.30,486.65,196.30,505.30,144.25,507.40,123.35,498.60,85.90,499.70,51.80,487.35,47.40,449.35,72.55,437.10,51.75,407.90,75.40,269.10,37.20,242.10,15.25,206.15,5.55,168.45,-14.35,154.55,-14.20,122.65,19.85,82.60,25.40,48.20,60.65,3.70,123.35,-16.45];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_pizzatower_brad.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 294.00;
	sprite.height = 493.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol46(this: IMayaAngelouCutouts_Symbol46) {
	return this;
}
function MayaAngelouCutouts_ang_pizzatower_brad(this: IMayaAngelouCutouts_ang_pizzatower_brad) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_pizzatower_brad.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_pizzatower_drz1(this: IMayaAngelouCutouts_ang_pizzatower_drz1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [61.55,-12.30,99.95,21.80,105.05,75.30,154.20,68.55,207.75,90.00,244.80,142.10,243.10,171.30,248.45,207.00,224.40,226.50,187.20,221.85,167.20,207.05,140.65,202.85,123.65,218.00,93.30,218.40,73.50,197.90,49.50,194.35,38.25,168.55,46.40,138.70,17.65,94.00,-4.90,86.15,-14.15,54.45,-7.75,14.15,17.00,-9.90];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_pizzatower_drz.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 236.00;
	sprite.height = 213.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol47(this: IMayaAngelouCutouts_Symbol47) {
	return this;
}
function MayaAngelouCutouts_ang_pizzatower_drz(this: IMayaAngelouCutouts_ang_pizzatower_drz) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_pizzatower_drz.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_pizzatower_yadina1(this: IMayaAngelouCutouts_ang_pizzatower_yadina1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [53.20,91.45,88.40,107.85,128.70,60.60,201.55,33.30,273.10,38.90,313.80,-12.75,353.40,-9.45,376.75,31.35,371.50,63.40,328.00,89.30,342.90,122.85,361.65,143.30,363.95,177.45,400.35,175.90,412.95,204.15,408.30,236.85,380.95,243.35,339.05,283.50,318.15,295.20,334.05,327.90,355.25,316.40,397.70,321.70,403.00,361.45,384.35,421.10,351.25,433.65,313.75,408.30,288.20,397.25,274.85,427.70,272.15,454.90,250.40,467.25,215.80,467.90,177.65,430.35,170.60,384.40,189.15,363.20,212.30,359.90,206.25,320.45,146.30,319.85,127.30,323.45,102.75,324.30,84.85,296.05,91.95,265.10,84.50,238.80,89.30,205.90,76.00,178.50,2.85,182.30,-17.15,138.65,-1.65,93.25];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_pizzatower_yadina.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 400.00;
	sprite.height = 455.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol48(this: IMayaAngelouCutouts_Symbol48) {
	return this;
}
function MayaAngelouCutouts_ang_pizzatower_yadina(this: IMayaAngelouCutouts_ang_pizzatower_yadina) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_pizzatower_yadina.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_raccoon1(this: IMayaAngelouCutouts_ang_raccoon1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [67.35,30.20,118.80,55.00,140.95,34.60,192.35,26.65,210.05,35.50,231.35,-6.15,274.75,-16.80,310.25,16.90,333.25,56.75,366.00,57.65,397.10,98.45,386.45,153.40,396.20,172.00,411.60,180.40,432.55,163.10,489.95,189.10,524.75,236.65,537.15,336.80,523.85,463.55,490.15,543.30,459.15,587.65,475.10,611.55,467.10,659.45,407.70,671.80,375.80,653.20,348.35,657.65,336.85,705.50,264.10,714.40,243.75,669.20,180.80,669.20,158.65,704.65,97.50,706.40,72.70,681.60,75.35,651.45,45.20,662.95,-4.45,652.35,-16.85,598.30,14.20,572.55,-3.55,505.20,-4.45,417.45,17.75,332.35,7.10,303.10,16.00,275.60,-9.70,235.70,17.75,127.60,8.90,77.15,23.95,31.95];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_raccoon.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 520.00;
	sprite.height = 696.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol49(this: IMayaAngelouCutouts_Symbol49) {
	return this;
}
function MayaAngelouCutouts_ang_raccoon(this: IMayaAngelouCutouts_ang_raccoon) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_raccoon.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_raccoon_drz1(this: IMayaAngelouCutouts_ang_raccoon_drz1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [186.70,34.60,187.80,78.85,214.40,93.05,215.10,124.45,202.50,144.20,216.55,201.10,260.45,193.80,296.15,169.55,338.45,174.10,373.30,201.75,429.20,243.35,453.30,315.45,443.55,367.00,482.25,386.15,480.65,443.50,423.30,479.70,262.25,423.00,232.90,424.35,205.35,411.45,148.70,414.45,123.60,366.10,95.15,347.45,90.30,307.15,106.70,284.35,86.25,235.55,61.40,220.00,54.25,183.10,74.70,131.55,104.05,111.10,112.25,63.10,134.50,57.10,163.70,29.15];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_raccoon_drz.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 511.00;
	sprite.height = 515.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol50(this: IMayaAngelouCutouts_Symbol50) {
	return this;
}
function MayaAngelouCutouts_ang_raccoon_drz(this: IMayaAngelouCutouts_ang_raccoon_drz) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_raccoon_drz.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_raccoon_drz_front1(this: IMayaAngelouCutouts_ang_raccoon_drz_front1) {
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_raccoon_drz_front.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 511.00;
	sprite.height = 515.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_ang_raccoon_drz_front(this: IMayaAngelouCutouts_ang_raccoon_drz_front) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_raccoon_drz_front.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_sandwich1(this: IMayaAngelouCutouts_ang_sandwich1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [360.25,-18.25,412.90,-4.00,468.80,-14.25,530.95,5.70,525.85,64.45,534.95,161.95,586.30,171.05,603.95,201.85,593.70,237.75,590.25,315.30,627.85,307.90,660.95,325.00,663.80,352.95,707.15,414.55,716.25,461.30,786.95,526.30,795.50,598.75,630.10,649.50,593.60,623.85,571.95,643.80,452.20,628.40,423.75,636.95,256.10,642.70,232.15,629.55,126.05,640.40,87.30,593.05,83.85,550.85,-10.20,530.35,-13.05,465.30,30.85,403.15,42.80,367.25,80.45,354.70,133.50,371.20,180.25,373.50,168.25,327.90,183.10,297.70,241.85,285.70,241.85,226.95,227.55,199.55,240.70,165.90,297.70,151.65,290.85,110.65,279.80,74.40,320.55,-6.85];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_sandwich.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 783.00;
	sprite.height = 634.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol51(this: IMayaAngelouCutouts_Symbol51) {
	return this;
}
function MayaAngelouCutouts_ang_sandwich(this: IMayaAngelouCutouts_ang_sandwich) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sandwich.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_sandwich_drz1(this: IMayaAngelouCutouts_ang_sandwich_drz1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [293.90,-3.50,328.65,81.60,315.00,159.80,346.85,192.95,348.25,232.15,376.20,240.55,398.10,283.85,391.55,341.10,347.20,358.80,262.85,336.50,205.90,346.50,144.80,338.15,84.35,357.40,41.30,355.25,22.80,337.10,-11.05,320.00,-13.70,250.15,44.75,225.15,37.25,202.40,71.10,154.05,128.60,126.40,123.10,72.05,149.05,24.00,218.20,-18.20];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_sandwich_drz.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 385.00;
	sprite.height = 342.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol52(this: IMayaAngelouCutouts_Symbol52) {
	return this;
}
function MayaAngelouCutouts_ang_sandwich_drz(this: IMayaAngelouCutouts_ang_sandwich_drz) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sandwich_drz.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_sea_bubbles11(this: IMayaAngelouCutouts_ang_sea_bubbles11) {
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_sea_bubbles1.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 304.00;
	sprite.height = 427.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_ang_sea_bubbles1(this: IMayaAngelouCutouts_ang_sea_bubbles1) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sea_bubbles1.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_sea_bubbles21(this: IMayaAngelouCutouts_ang_sea_bubbles21) {
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_sea_bubbles2.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 499.00;
	sprite.height = 427.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_ang_sea_bubbles2(this: IMayaAngelouCutouts_ang_sea_bubbles2) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sea_bubbles2.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_sea_drz1(this: IMayaAngelouCutouts_ang_sea_drz1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [226.20,129.10,231.40,60.35,259.40,9.85,326.70,-16.80,370.20,-2.75,398.30,43.50,405.30,105.80,383.20,139.45,357.00,146.35,306.70,200.10,319.70,228.60,312.70,267.05,277.65,281.85,251.15,306.20,178.50,301.10,111.75,317.90,52.45,345.60,2.85,343.10,-11.70,302.60,-0.05,264.65,-16.30,248.20,15.15,185.95,69.35,137.85,145.40,111.75];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_sea_drz.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 389.00;
	sprite.height = 333.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol53(this: IMayaAngelouCutouts_Symbol53) {
	return this;
}
function MayaAngelouCutouts_ang_sea_drz(this: IMayaAngelouCutouts_ang_sea_drz) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sea_drz.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_sea_left1(this: IMayaAngelouCutouts_ang_sea_left1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [119.00,58.40,134.40,90.60,128.55,138.55,176.10,141.80,188.35,108.70,209.25,101.50,194.10,30.20,199.90,-9.40,236.60,-12.25,253.15,20.15,253.15,52.55,275.45,66.25,265.40,125.25,286.30,141.10,286.30,171.35,275.15,212.05,283.40,226.05,305.00,190.05,339.90,195.75,343.15,237.60,402.80,241.90,453.30,268.45,452.60,301.60,423.80,315.25,395.00,321.00,361.15,318.15,346.40,359.80,365.05,370.75,374.80,409.60,388.10,420.85,386.80,446.35,366.55,461.50,380.60,485.20,381.30,520.45,361.15,544.95,315.55,548.85,295.15,533.05,257.30,531.25,225.35,554.40,176.60,554.60,150.90,537.05,100.45,524.00,76.65,501.40,23.45,501.05,4.85,489.50,6.15,444.85,-15.05,402.10,-8.60,343.65,19.85,336.15,25.25,316.15,40.75,303.75,27.45,259.25,44.35,237.50,27.45,177.45,36.05,120.20,67.35,118.00,73.15,71.90,87.65,53.60];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_sea_left.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 444.00;
	sprite.height = 541.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol55(this: IMayaAngelouCutouts_Symbol55) {
	return this;
}
function MayaAngelouCutouts_ang_sea_left(this: IMayaAngelouCutouts_ang_sea_left) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sea_left.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_sea_fish1(this: IMayaAngelouCutouts_ang_sea_fish1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [92.80,-12.20,146.75,19.45,179.50,78.20,175.90,111.20,138.85,146.05,122.30,170.50,66.35,180.15,34.60,167.60,25.20,132.35,5.10,133.10,-15.05,93.55,-5.35,48.25,25.20,47.50,30.95,12.25,67.30,-13.25];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_sea_fish.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 167.00;
	sprite.height = 167.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol54(this: IMayaAngelouCutouts_Symbol54) {
	return this;
}
function MayaAngelouCutouts_ang_sea_fish(this: IMayaAngelouCutouts_ang_sea_fish) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sea_fish.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_sea_right1(this: IMayaAngelouCutouts_ang_sea_right1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [138.50,-10.80,145.75,15.20,170.25,20.95,195.50,72.15,184.70,124.10,200.30,128.80,222.15,163.40,220.45,185.50,202.70,214.85,183.95,226.45,172.40,242.30,119.05,256.75,64.85,255.20,18.80,232.95,-7.90,224.25,-12.95,193.25,2.15,161.95,20.65,154.30,30.30,118.40,53.40,108.95,56.30,72.15,72.15,67.35,80.10,24.60,98.15,19.80,104.60,-9.35];
	}
	if (!polygons[1] && polygons.elementFactory) {
		polygons[1] = polygons.elementFactory(1,undefined);
	}
	if (polygons[1]) {
		polygons[1] = [413.60,116.60,426.95,76.80,428.35,3.85,466.45,0.75,477.75,54.90,490.40,67.80,492.20,98.90,514.00,94.20,530.90,110.10,553.95,76.85,555.70,43.35,537.65,18.80,536.25,-11.55,563.65,-7.20,595.05,33.95,599.00,67.85,614.85,91.35,614.90,149.45,625.00,225.95,645.95,221.60,666.85,235.30,679.15,287.30,677.40,326.25,640.15,338.50,613.45,352.95,529.60,361.20,444.20,349.90,405.20,332.35,369.50,325.50,361.25,304.80,368.85,260.65,385.40,220.10,399.00,180.15,360.10,191.25,312.35,185.75,279.95,163.35,268.45,131.60,283.35,111.15,354.35,119.10];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_sea_right.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 667.00;
	sprite.height = 346.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol56(this: IMayaAngelouCutouts_Symbol56) {
	return this;
}
function MayaAngelouCutouts_Symbol57(this: IMayaAngelouCutouts_Symbol57) {
	return this;
}
function MayaAngelouCutouts_ang_sea_right(this: IMayaAngelouCutouts_ang_sea_right) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sea_right.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_sea_whale1(this: IMayaAngelouCutouts_ang_sea_whale1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [25.30,83.80,50.80,67.75,142.45,51.30,250.60,56.35,279.55,18.80,335.85,-12.30,366.20,-9.40,368.35,14.45,345.25,54.20,346.65,84.50,407.40,119.90,455.75,155.25,491.90,209.45,547.50,198.60,614.65,214.50,619.70,244.10,570.60,253.50,528.75,274.40,506.35,278.05,486.15,288.90,443.50,304.80,427.60,319.20,401.60,320.70,395.85,292.50,417.50,255.65,382.10,249.90,282.45,252.80,218.15,249.90,216.00,278.80,192.90,283.80,158.95,273.00,133.65,241.95,80.95,221.00,45.55,199.30,24.60,172.60,-4.25,153.80,-13.25,124.50,-7.15,99.60];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_sea_whale.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 606.00;
	sprite.height = 312.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol58(this: IMayaAngelouCutouts_Symbol58) {
	return this;
}
function MayaAngelouCutouts_ang_sea_whale(this: IMayaAngelouCutouts_ang_sea_whale) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sea_whale.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_shower1(this: IMayaAngelouCutouts_ang_shower1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [46.10,-10.50,923.50,-11.00,1002.65,-5.80,1003.75,28.70,962.15,38.25,970.60,238.70,967.30,318.65,953.60,398.45,921.50,496.35,884.40,564.50,817.25,648.95,963.40,651.50,992.65,666.80,1003.70,689.85,996.70,720.90,967.60,732.95,936.50,734.95,856.05,907.60,857.30,935.50,849.30,968.55,862.95,985.20,864.40,1016.05,854.30,1029.75,829.55,1036.85,801.50,1029.20,791.15,1006.70,765.05,970.60,728.95,976.60,580.55,979.60,419.15,977.60,208.90,968.60,178.05,1008.30,169.45,1030.75,138.40,1036.75,107.30,1023.50,108.45,986.80,121.35,967.60,114.30,941.50,115.60,905.90,72.10,821.55,34.00,733.55,2.00,725.95,-13.70,701.95,-6.15,671.85,24.05,652.75,57.15,651.75,52.15,381.05,55.90,38.75,13.05,30.10,11.85,-2.55];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_shower.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 995.00;
	sprite.height = 1023.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol59(this: IMayaAngelouCutouts_Symbol59) {
	return this;
}
function MayaAngelouCutouts_ang_shower(this: IMayaAngelouCutouts_ang_shower) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_shower.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_shower_dzr1(this: IMayaAngelouCutouts_ang_shower_dzr1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [136.00,61.55,171.70,76.55,186.70,26.90,213.05,-2.05,257.55,-13.95,284.40,-4.65,306.65,24.85,309.20,74.95,292.70,103.95,265.80,111.70,231.70,142.75,234.25,177.40,216.15,197.05,171.70,192.90,121.55,203.75,72.95,207.90,33.65,220.80,0.00,214.60,-13.95,190.30,-10.85,163.95,-0.50,156.70,-3.60,125.70,33.10,85.35,95.15,61.05];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_shower_dzr.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 296.00;
	sprite.height = 207.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol60(this: IMayaAngelouCutouts_Symbol60) {
	return this;
}
function MayaAngelouCutouts_ang_shower_dzr(this: IMayaAngelouCutouts_ang_shower_dzr) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_shower_dzr.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_shower_dzr_front1(this: IMayaAngelouCutouts_ang_shower_dzr_front1) {
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_shower_dzr_front.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 86.00;
	sprite.height = 67.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_ang_shower_dzr_front(this: IMayaAngelouCutouts_ang_shower_dzr_front) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_shower_dzr_front.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_shower_note11(this: IMayaAngelouCutouts_ang_shower_note11) {
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_shower_note1.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 57.00;
	sprite.height = 105.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_ang_shower_note1(this: IMayaAngelouCutouts_ang_shower_note1) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_shower_note1.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_shower_note21(this: IMayaAngelouCutouts_ang_shower_note21) {
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_shower_note2.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 74.00;
	sprite.height = 94.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_ang_shower_note2(this: IMayaAngelouCutouts_ang_shower_note2) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_shower_note2.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_shower_notes1(this: IMayaAngelouCutouts_ang_shower_notes1) {
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_shower_notes.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 298.00;
	sprite.height = 618.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_ang_shower_notes(this: IMayaAngelouCutouts_ang_shower_notes) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_shower_notes.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_sittingstill1(this: IMayaAngelouCutouts_ang_sittingstill1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [1269.65,23.25,1284.15,46.65,1278.05,103.40,1324.70,101.35,1376.35,104.45,1382.45,134.80,1359.85,345.55,1490.90,383.90,1472.65,453.00,1454.40,458.10,1448.35,476.35,1438.20,479.40,1430.10,508.75,1479.55,515.20,1506.10,526.00,1597.25,542.40,1696.75,596.05,1696.65,633.45,1658.15,657.80,1594.30,672.00,1545.55,692.75,1489.90,701.35,1404.75,699.35,1303.40,723.65,1222.45,729.45,1137.15,725.70,997.80,737.80,867.15,730.00,827.30,735.60,789.55,728.70,695.30,725.70,613.20,712.50,564.55,718.60,462.05,712.95,369.95,696.30,236.20,692.25,128.75,672.95,93.00,655.30,27.75,640.35,0.90,616.30,0.95,584.70,27.10,558.30,289.45,506.40,285.80,476.35,272.65,473.30,267.60,457.10,249.35,451.00,232.20,380.70,359.55,344.85,336.55,123.65,349.50,102.95,441.95,100.35,434.20,46.40,451.00,22.25,586.90,-3.10,753.95,-15.55,1013.00,-12.25,1160.50,0.30];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_sittingstill.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1686.00;
	sprite.height = 722.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol63(this: IMayaAngelouCutouts_Symbol63) {
	return this;
}
function MayaAngelouCutouts_ang_sittingstill(this: IMayaAngelouCutouts_ang_sittingstill) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sittingstill.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_sittingstill_clock1(this: IMayaAngelouCutouts_ang_sittingstill_clock1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [216.75,0.05,275.75,46.85,300.15,98.70,308.30,154.65,288.95,221.80,243.20,269.60,179.10,298.10,126.20,301.15,70.25,281.85,12.25,233.00,-15.20,162.80,-7.10,95.65,26.50,36.65,84.45,-1.00,145.50,-13.20];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_sittingstill_clock.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 294.00;
	sprite.height = 286.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol64(this: IMayaAngelouCutouts_Symbol64) {
	return this;
}
function MayaAngelouCutouts_ang_sittingstill_clock(this: IMayaAngelouCutouts_ang_sittingstill_clock) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sittingstill_clock.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_sittingstill_clock_handHr1(this: IMayaAngelouCutouts_ang_sittingstill_clock_handHr1) {
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_sittingstill_clock_handHr.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 6.00;
	sprite.height = 46.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_ang_sittingstill_clock_handHr(this: IMayaAngelouCutouts_ang_sittingstill_clock_handHr) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sittingstill_clock_hand-hr.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_sittingstill_clock_handMin1(this: IMayaAngelouCutouts_ang_sittingstill_clock_handMin1) {
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_sittingstill_clock_handMin.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 6.00;
	sprite.height = 71.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_ang_sittingstill_clock_handMin(this: IMayaAngelouCutouts_ang_sittingstill_clock_handMin) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sittingstill_clock_hand-min.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_sittingstill_drz1(this: IMayaAngelouCutouts_ang_sittingstill_drz1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [85.30,5.90,118.55,-12.35,156.30,-9.75,175.85,17.60,179.40,49.35,172.60,71.65,184.90,83.20,189.50,108.75,213.60,132.85,228.05,163.25,227.30,229.80,196.40,244.70,185.60,274.15,153.70,277.40,132.20,286.95,-4.55,264.65,-15.60,244.85,18.25,65.80,37.15,50.80,71.65,53.40,71.00,38.45];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_sittingstill_drz.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 216.00;
	sprite.height = 274.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol65(this: IMayaAngelouCutouts_Symbol65) {
	return this;
}
function MayaAngelouCutouts_ang_sittingstill_drz(this: IMayaAngelouCutouts_ang_sittingstill_drz) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sittingstill_drz.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_sled1(this: IMayaAngelouCutouts_ang_sled1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [129.85,197.60,142.25,168.00,288.05,173.55,296.40,199.70,403.25,200.20,411.70,173.10,561.00,174.30,568.60,198.45,712.35,197.20,721.25,170.45,872.20,172.20,879.00,193.35,937.50,189.55,974.40,166.65,985.85,127.20,968.05,86.50,927.35,71.25,876.45,61.05,871.35,10.20,891.70,-14.00,1034.20,-2.55,1086.35,22.90,1133.40,82.70,1141.05,157.75,1114.35,219.25,1070.75,260.20,978.90,273.85,783.60,281.30,87.80,277.30,-14.70,268.90,-6.70,193.85];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_sled.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1126.00;
	sprite.height = 267.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol66(this: IMayaAngelouCutouts_Symbol66) {
	return this;
}
function MayaAngelouCutouts_ang_sled(this: IMayaAngelouCutouts_ang_sled) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sled.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_sled_drz1(this: IMayaAngelouCutouts_ang_sled_drz1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [244.80,5.10,269.05,70.15,278.65,112.45,267.75,141.55,262.65,175.95,315.45,195.25,351.90,246.10,349.30,277.65,401.65,297.10,400.35,374.85,365.95,381.25,328.45,406.85,246.10,386.35,184.90,391.45,123.35,379.25,61.70,397.55,12.75,395.25,-12.75,350.65,-0.55,296.50,44.65,271.60,43.10,232.20,74.15,201.35,61.20,154.30,72.70,96.90,71.30,60.20,123.45,-5.10,189.20,-15.05];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_sled_drz.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 389.00;
	sprite.height = 390.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol67(this: IMayaAngelouCutouts_Symbol67) {
	return this;
}
function MayaAngelouCutouts_ang_sled_drz(this: IMayaAngelouCutouts_ang_sled_drz) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sled_drz.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_sled_pillow_back1(this: IMayaAngelouCutouts_ang_sled_pillow_back1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [175.75,34.35,290.30,24.55,408.80,39.85,419.30,8.20,458.95,10.25,548.90,-13.25,677.65,-13.25,766.60,13.30,789.10,2.05,819.20,7.70,815.65,54.20,822.80,120.95,811.55,175.80,817.10,202.30,799.35,218.65,765.10,213.55,666.00,224.85,527.40,221.80,507.00,246.20,408.45,278.45,268.85,292.35,148.25,284.15,57.45,258.10,11.85,228.40,-14.30,173.75,-9.15,127.80,28.65,86.90,81.30,61.40];
	}
	if (!polygons[1] && polygons.elementFactory) {
		polygons[1] = polygons.elementFactory(1,undefined);
	}
	if (polygons[1]) {
		polygons[1] = [992.25,51.75,1057.85,10.65,1137.55,-12.35,1237.95,-13.25,1322.95,1.05,1364.95,16.45,1397.30,5.20,1431.50,10.30,1493.95,1.05,1585.10,12.35,1628.10,31.80,1666.90,34.25,1679.30,53.30,1675.65,85.40,1659.35,100.90,1645.55,182.30,1607.65,240.70,1574.90,262.60,1537.00,276.50,1524.75,299.00,1489.45,298.45,1471.45,289.85,1406.00,281.60,1334.25,263.20,1298.40,239.65,1275.85,220.20,1244.85,217.65,1120.20,208.95,1035.15,188.90,988.60,159.55,979.95,102.30];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_sled_pillow_back.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1666.00;
	sprite.height = 285.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol68(this: IMayaAngelouCutouts_Symbol68) {
	return this;
}
function MayaAngelouCutouts_Symbol69(this: IMayaAngelouCutouts_Symbol69) {
	return this;
}
function MayaAngelouCutouts_ang_sled_pillow_back(this: IMayaAngelouCutouts_ang_sled_pillow_back) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sled_pillow_back.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_sled_pillow_front1(this: IMayaAngelouCutouts_ang_sled_pillow_front1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [50.85,23.80,110.65,-3.25,216.30,-17.15,326.90,-4.05,367.35,-11.40,409.65,3.35,412.10,26.25,464.45,50.80,507.90,102.40,534.90,167.15,579.50,180.30,585.25,214.00,569.40,236.25,528.35,245.80,490.75,278.50,426.00,299.00,347.35,317.05,269.55,324.40,244.15,335.05,190.55,333.25,180.70,307.85,121.10,289.35,62.30,245.75,27.90,181.05,17.20,137.15,17.25,97.50,-11.30,78.70,-11.40,38.50,16.15,19.90];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_sled_pillow_front.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 573.00;
	sprite.height = 323.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol70(this: IMayaAngelouCutouts_Symbol70) {
	return this;
}
function MayaAngelouCutouts_ang_sled_pillow_front(this: IMayaAngelouCutouts_ang_sled_pillow_front) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sled_pillow_front.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_sleepyhead_bed1(this: IMayaAngelouCutouts_ang_sleepyhead_bed1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [48.60,-12.80,70.25,11.85,125.05,33.25,140.50,17.05,191.00,20.40,202.15,57.15,213.70,62.50,218.55,97.80,258.60,95.85,305.85,106.35,335.80,111.20,336.05,181.80,381.90,188.40,494.15,179.20,585.35,184.45,703.50,183.80,802.60,189.05,850.50,181.80,850.65,21.15,912.20,18.40,920.85,-9.20,993.00,-7.70,993.95,429.70,927.30,431.15,910.90,416.05,866.35,413.40,851.15,400.30,669.40,394.40,437.10,399.00,202.15,400.30,184.30,411.05,133.70,412.00,128.00,399.00,66.30,397.00,54.10,425.75,-10.80,424.05,-9.20,282.15,-14.40,122.75,-5.90,-11.45];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_sleepyhead_bed.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 980.00;
	sprite.height = 418.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol71(this: IMayaAngelouCutouts_Symbol71) {
	return this;
}
function MayaAngelouCutouts_ang_sleepyhead_bed(this: IMayaAngelouCutouts_ang_sleepyhead_bed) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sleepyhead_bed.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_sleepyhead_drz1(this: IMayaAngelouCutouts_ang_sleepyhead_drz1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [416.40,31.85,413.00,83.90,385.75,97.90,358.60,137.25,360.60,175.20,388.50,196.25,413.70,228.65,463.85,201.20,512.95,201.30,527.05,256.70,511.55,303.20,437.20,307.55,437.70,326.50,451.25,364.35,443.85,406.15,409.60,426.85,361.50,472.95,372.15,488.60,402.85,467.25,448.90,476.75,460.70,538.70,429.35,558.45,395.05,555.85,389.65,640.30,338.25,664.55,283.75,659.15,266.50,622.60,207.25,616.85,199.85,583.95,146.40,588.10,115.15,571.65,123.35,509.10,154.35,493.10,190.00,507.50,203.15,474.60,164.50,456.50,142.30,431.80,104.45,420.30,82.65,371.40,92.95,334.75,101.50,329.00,97.80,307.95,11.50,323.25,-15.65,278.00,-7.40,216.30,66.00,204.00,121.75,233.60,151.70,203.65,145.25,170.25,182.30,112.20,235.70,81.45,294.00,84.75,294.50,31.20,326.70,-9.45,379.40,-11.80];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_sleepyhead_drz.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 510.00;
	sprite.height = 653.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol72(this: IMayaAngelouCutouts_Symbol72) {
	return this;
}
function MayaAngelouCutouts_ang_sleepyhead_drz(this: IMayaAngelouCutouts_ang_sleepyhead_drz) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sleepyhead_drz.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_sleepyhead_z1(this: IMayaAngelouCutouts_ang_sleepyhead_z1) {
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_sleepyhead_z.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 53.00;
	sprite.height = 83.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_ang_sleepyhead_z(this: IMayaAngelouCutouts_ang_sleepyhead_z) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sleepyhead_z.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_sleepyhead_zzz1(this: IMayaAngelouCutouts_ang_sleepyhead_zzz1) {
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_sleepyhead_zzz.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 83.00;
	sprite.height = 303.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_ang_sleepyhead_zzz(this: IMayaAngelouCutouts_ang_sleepyhead_zzz) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sleepyhead_zzz.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_smart1(this: IMayaAngelouCutouts_ang_smart1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [992.40,-12.90,992.85,747.25,1066.35,750.50,1071.65,787.90,1050.40,824.55,1008.55,831.65,984.55,808.40,961.40,813.05,951.00,843.25,904.00,850.45,880.85,820.70,844.10,814.95,842.05,765.40,916.90,754.35,916.95,639.55,150.85,632.60,150.90,719.55,219.90,725.70,222.55,769.35,201.20,802.00,154.75,805.95,134.15,785.30,110.85,786.80,100.60,817.25,43.85,822.70,25.80,794.35,-10.95,786.60,-14.30,740.95,72.30,730.60,72.55,631.60,32.90,626.60,32.45,570.50,75.95,568.40,75.30,-10.95];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_smart.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1056.00;
	sprite.height = 835.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol73(this: IMayaAngelouCutouts_Symbol73) {
	return this;
}
function MayaAngelouCutouts_ang_smart(this: IMayaAngelouCutouts_ang_smart) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_smart.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_smart_drz1(this: IMayaAngelouCutouts_ang_smart_drz1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [134.65,-13.25,166.45,19.90,177.10,35.85,174.45,67.65,193.20,82.25,208.50,118.95,222.20,135.90,220.55,168.00,190.60,175.40,200.95,206.40,189.00,234.75,159.15,244.00,123.95,229.65,115.70,173.70,106.80,173.70,97.50,222.80,75.60,233.40,46.45,233.40,26.55,212.85,30.50,173.05,-10.35,168.70,-12.00,121.40,15.95,113.35,29.25,80.25,57.05,58.40,57.65,28.00,90.00,-12.25];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_smart_drz.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 210.00;
	sprite.height = 229.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol74(this: IMayaAngelouCutouts_Symbol74) {
	return this;
}
function MayaAngelouCutouts_ang_smart_drz(this: IMayaAngelouCutouts_ang_smart_drz) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_smart_drz.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_spoon1(this: IMayaAngelouCutouts_ang_spoon1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [728.15,-18.15,791.65,-3.90,805.30,31.25,790.35,84.35,414.00,260.85,369.90,365.95,279.05,441.20,168.75,469.75,57.15,458.05,-7.75,413.95,-15.55,343.85,13.60,284.35,106.70,237.00,310.05,189.05];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_spoon.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 788.00;
	sprite.height = 453.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol75(this: IMayaAngelouCutouts_Symbol75) {
	return this;
}
function MayaAngelouCutouts_ang_spoon(this: IMayaAngelouCutouts_ang_spoon) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_spoon.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_spoon_drz1(this: IMayaAngelouCutouts_ang_spoon_drz1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [94.65,-8.60,106.00,35.15,136.75,45.20,136.10,72.30,128.90,91.65,145.45,119.85,149.70,151.30,195.50,130.00,230.15,100.55,273.15,101.15,303.10,120.40,360.95,144.05,395.80,190.20,409.20,228.00,404.35,248.80,319.10,308.45,244.60,331.35,239.20,353.75,208.85,360.65,180.05,355.85,144.35,370.25,111.85,359.60,92.70,326.55,58.95,312.60,49.20,277.50,59.65,253.05,31.90,205.10,4.60,195.25,-8.55,157.50,0.70,108.75,25.90,74.65,29.00,28.65,49.80,20.10,68.75,-12.25];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_spoon_drz.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 395.00;
	sprite.height = 371.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol76(this: IMayaAngelouCutouts_Symbol76) {
	return this;
}
function MayaAngelouCutouts_ang_spoon_drz(this: IMayaAngelouCutouts_ang_spoon_drz) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_spoon_drz.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_springs_butterflies_11(this: IMayaAngelouCutouts_ang_springs_butterflies_11) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [21.40,122.55,46.15,136.65,83.35,132.80,97.00,139.65,101.70,170.00,85.50,185.40,62.85,211.40,2.15,201.15,-13.20,154.15,-7.25,123.00];
	}
	if (!polygons[1] && polygons.elementFactory) {
		polygons[1] = polygons.elementFactory(1,undefined);
	}
	if (polygons[1]) {
		polygons[1] = [248.40,-8.10,281.00,25.65,320.15,33.25,336.00,44.90,333.90,71.80,307.40,90.60,289.80,106.10,262.95,110.30,244.95,104.70,239.00,92.75,216.15,90.25,205.10,65.30,208.20,37.20,208.50,6.20,220.60,-9.40];
	}
	if (!polygons[2] && polygons.elementFactory) {
		polygons[2] = polygons.elementFactory(2,undefined);
	}
	if (polygons[2]) {
		polygons[2] = [257.70,177.95,277.05,219.85,294.65,227.25,304.00,245.95,347.60,268.50,346.30,299.70,322.50,317.60,299.50,320.80,273.80,332.05,245.50,333.10,225.15,322.40,221.40,301.55,202.15,297.30,188.25,280.15,189.90,241.10,201.70,220.00,206.45,191.95,228.10,172.70];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_springs_butterflies_1.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 337.00;
	sprite.height = 321.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol77(this: IMayaAngelouCutouts_Symbol77) {
	return this;
}
function MayaAngelouCutouts_Symbol78(this: IMayaAngelouCutouts_Symbol78) {
	return this;
}
function MayaAngelouCutouts_Symbol79(this: IMayaAngelouCutouts_Symbol79) {
	return this;
}
function MayaAngelouCutouts_ang_springs_butterflies_1(this: IMayaAngelouCutouts_ang_springs_butterflies_1) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_springs_butterflies_1.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_springs_butterflies_21(this: IMayaAngelouCutouts_ang_springs_butterflies_21) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [-8.00,56.25,42.85,34.85,80.85,-11.20,112.90,-8.55,126.35,34.30,129.55,71.25,122.55,94.25,99.05,100.65,86.20,122.60,65.85,125.80,35.95,118.35,12.30,104.95,-12.30,86.75];
	}
	if (!polygons[1] && polygons.elementFactory) {
		polygons[1] = polygons.elementFactory(1,undefined);
	}
	if (polygons[1]) {
		polygons[1] = [146.70,226.90,200.20,221.00,265.55,189.45,294.95,196.40,299.75,238.70,283.70,310.40,260.70,329.65,236.60,325.40,217.90,341.45,179.90,340.90,118.30,271.85,118.30,236.00];
	}
	if (!polygons[2] && polygons.elementFactory) {
		polygons[2] = polygons.elementFactory(2,undefined);
	}
	if (polygons[2]) {
		polygons[2] = [346.80,80.90,395.05,78.20,428.25,56.80,456.00,57.90,463.00,88.90,451.80,142.95,424.45,147.25,408.45,157.45,376.30,152.60,342.00,104.95];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_springs_butterflies_2.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 450.00;
	sprite.height = 331.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol80(this: IMayaAngelouCutouts_Symbol80) {
	return this;
}
function MayaAngelouCutouts_Symbol81(this: IMayaAngelouCutouts_Symbol81) {
	return this;
}
function MayaAngelouCutouts_Symbol82(this: IMayaAngelouCutouts_Symbol82) {
	return this;
}
function MayaAngelouCutouts_ang_springs_butterflies_2(this: IMayaAngelouCutouts_ang_springs_butterflies_2) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_springs_butterflies_2.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_springs_drz1(this: IMayaAngelouCutouts_ang_springs_drz1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [172.60,40.80,248.95,42.90,263.60,5.25,290.80,-16.75,351.45,-4.20,381.80,33.50,386.00,111.85,458.15,132.85,508.35,211.30,515.70,251.00,538.70,275.05,542.85,349.25,507.25,464.40,441.40,523.95,359.85,559.55,264.65,556.40,188.30,525.00,139.15,461.25,138.10,369.20,53.40,351.40,-11.45,312.70,-14.60,255.15,16.75,237.40,55.50,248.90,35.60,176.80,52.35,111.95,91.05,75.30];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_springs_drz.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 527.00;
	sprite.height = 544.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol83(this: IMayaAngelouCutouts_Symbol83) {
	return this;
}
function MayaAngelouCutouts_ang_springs_drz(this: IMayaAngelouCutouts_ang_springs_drz) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_springs_drz.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_springs_duck_left1(this: IMayaAngelouCutouts_ang_springs_duck_left1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [193.50,-2.65,222.25,38.15,227.60,108.45,267.10,113.15,282.55,83.65,318.00,85.00,328.70,119.85,343.40,136.55,342.75,197.50,316.65,269.80,279.80,299.20,244.35,313.30,226.70,319.15,200.65,321.00,177.80,321.10,161.35,315.95,114.50,297.90,81.00,249.00,81.70,201.50,24.10,188.80,-12.70,160.00,-11.35,121.15,5.35,111.80,28.15,116.50,20.10,85.00,25.45,39.50,62.25,-0.65,126.55,-16.05];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_springs_duck_left.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 331.00;
	sprite.height = 305.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol84(this: IMayaAngelouCutouts_Symbol84) {
	return this;
}
function MayaAngelouCutouts_ang_springs_duck_left(this: IMayaAngelouCutouts_ang_springs_duck_left) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_springs_duck_left.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_springs_duck_right1(this: IMayaAngelouCutouts_ang_springs_duck_right1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [293.90,6.00,330.70,39.20,339.30,85.35,328.75,125.20,367.80,124.80,377.25,163.45,353.90,192.45,302.60,212.20,269.80,218.25,271.80,268.45,251.05,311.25,213.60,334.70,184.15,343.50,165.85,347.50,140.30,348.30,118.10,348.25,96.30,343.75,50.05,321.90,11.40,279.15,-8.00,225.55,-15.05,170.65,-6.15,137.95,6.75,132.50,10.35,95.95,48.10,93.20,73.00,123.15,117.20,116.45,113.85,67.60,133.90,15.40,180.80,-12.05,247.75,-13.90];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_springs_duck_right.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 361.00;
	sprite.height = 334.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol85(this: IMayaAngelouCutouts_Symbol85) {
	return this;
}
function MayaAngelouCutouts_ang_springs_duck_right(this: IMayaAngelouCutouts_ang_springs_duck_right) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_springs_duck_right.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_springs_spring1(this: IMayaAngelouCutouts_ang_springs_spring1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [80.80,197.00,32.25,197.65,0.05,174.20,-4.65,-9.35,61.00,-12.70,110.60,2.00,118.00,180.90];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_springs_spring.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 108.00;
	sprite.height = 181.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol86(this: IMayaAngelouCutouts_Symbol86) {
	return this;
}
function MayaAngelouCutouts_ang_springs_spring(this: IMayaAngelouCutouts_ang_springs_spring) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_springs_spring.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_swing_bg1(this: IMayaAngelouCutouts_ang_swing_bg1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [8.40,1002.90,-15.65,974.75,145.70,140.70,152.30,74.50,134.40,61.95,127.35,23.00,140.25,-13.10,1603.50,-12.20,1615.20,32.40,1604.15,66.30,1575.50,72.85,1590.35,137.40,1746.85,980.15,1719.10,999.80,1676.50,994.15,1505.80,123.20,1508.85,22.95,242.50,32.70,54.65,994.60];
	}
	if (!polygons[1] && polygons.elementFactory) {
		polygons[1] = polygons.elementFactory(1,undefined);
	}
	if (polygons[1]) {
		polygons[1] = [650.20,75.55,652.75,769.45,679.10,795.75,678.25,844.30,358.35,844.20,360.25,787.45,382.35,772.55,375.70,76.35,299.30,77.30,298.50,156.90,360.05,930.55,327.45,947.35,290.40,939.30,266.95,652.90,88.15,644.50,110.90,570.70,260.25,579.80,225.40,139.45,227.55,27.00,431.55,28.75,434.90,770.30,599.25,770.30,595.85,29.55,1130.20,32.90,1134.90,770.25,1301.80,770.85,1295.35,31.20,1506.60,34.80,1506.10,119.95,1471.85,581.95,1623.40,569.90,1640.30,645.60,1466.55,653.65,1444.40,933.05,1417.00,946.75,1389.05,942.50,1373.75,913.50,1432.65,149.85,1433.85,75.40,1350.55,75.40,1352.70,772.80,1375.85,792.85,1372.75,843.45,1060.65,845.05,1056.40,790.75,1080.65,775.95,1078.45,76.25];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_swing_bg.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1732.00;
	sprite.height = 988.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol88(this: IMayaAngelouCutouts_Symbol88) {
	return this;
}
function MayaAngelouCutouts_Symbol87(this: IMayaAngelouCutouts_Symbol87) {
	return this;
}
function MayaAngelouCutouts_ang_swing_bg(this: IMayaAngelouCutouts_ang_swing_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_swing_bg.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_swing_drz1(this: IMayaAngelouCutouts_ang_swing_drz1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [441.05,-11.15,462.95,305.05,541.75,285.25,582.75,298.70,588.95,357.45,565.00,408.35,500.10,401.10,517.15,421.75,510.65,474.85,479.45,506.95,493.30,565.05,483.75,588.70,490.65,673.05,545.00,676.05,548.30,731.50,519.60,756.15,473.45,759.15,434.85,797.20,382.20,817.65,330.55,805.60,317.65,770.35,298.70,804.75,251.35,813.35,205.75,793.55,175.60,761.70,120.55,759.15,89.55,726.45,91.95,676.40,144.65,673.95,144.15,585.25,132.75,555.60,146.60,521.70,111.05,515.55,81.45,474.70,83.35,424.95,116.25,404.50,111.25,395.35,20.25,425.40,-13.75,380.40,-10.70,309.05,56.00,292.40,133.45,311.55,154.10,286.60,167.10,-9.45,217.85,-8.20,212.15,245.35,278.05,228.10,346.05,233.30,403.80,254.25,389.10,-10.30];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_swing_drz.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 573.00;
	sprite.height = 800.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol89(this: IMayaAngelouCutouts_Symbol89) {
	return this;
}
function MayaAngelouCutouts_ang_swing_drz(this: IMayaAngelouCutouts_ang_swing_drz) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_swing_drz.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_teaset1(this: IMayaAngelouCutouts_ang_teaset1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [96.70,20.75,163.60,23.00,242.60,42.40,306.30,29.35,341.50,54.35,361.35,27.25,383.75,19.00,397.10,-14.25,453.40,-12.55,466.45,18.15,503.60,47.45,538.10,27.60,595.85,37.10,609.25,97.75,576.05,150.05,564.80,191.75,515.65,199.20,505.30,224.20,455.60,239.70,395.65,240.65,345.80,224.20,338.90,203.50,321.45,183.85,290.25,142.75,283.70,95.75,247.50,77.60,238.00,105.20,237.15,132.80,267.70,141.35,268.55,176.65,210.75,202.20,72.35,204.35,34.50,193.15,-10.35,177.65,-9.50,141.45,48.30,125.05,51.75,77.60,41.40,64.70,49.15,34.50];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_teaset.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 593.00;
	sprite.height = 227.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol90(this: IMayaAngelouCutouts_Symbol90) {
	return this;
}
function MayaAngelouCutouts_ang_teaset(this: IMayaAngelouCutouts_ang_teaset) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_teaset.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_turtle_drz1(this: IMayaAngelouCutouts_ang_turtle_drz1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [244.30,-14.65,272.35,-8.20,276.25,12.95,510.60,70.15,520.95,113.85,475.95,145.75,361.80,196.20,410.65,307.50,425.60,228.80,443.65,171.05,498.25,139.10,551.75,130.45,589.35,161.60,601.60,216.70,590.35,272.45,559.60,293.35,527.45,290.95,517.10,304.75,557.40,312.75,558.50,364.30,568.90,385.05,568.25,410.10,554.55,425.05,553.35,448.05,594.55,454.50,596.50,511.00,638.80,552.40,631.65,599.55,257.80,601.15,242.60,574.85,256.55,540.35,189.90,565.35,113.10,565.35,23.65,528.25,-15.70,427.25,-1.70,383.20,-11.20,361.65,-5.00,320.35,49.20,323.65,69.05,289.15,120.00,282.55,134.25,330.80,157.65,322.50,258.10,343.50,303.00,290.85,356.55,291.75,319.40,209.75,176.10,252.90,130.90,251.80,129.50,212.35,229.20,39.30,219.75,24.60,220.15,3.45];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_turtle_drz.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 627.00;
	sprite.height = 588.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol91(this: IMayaAngelouCutouts_Symbol91) {
	return this;
}
function MayaAngelouCutouts_ang_turtle_drz(this: IMayaAngelouCutouts_ang_turtle_drz) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_turtle_drz.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_turtle_left1(this: IMayaAngelouCutouts_ang_turtle_left1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [142.75,666.70,95.65,656.90,96.80,636.55,119.35,630.55,121.30,609.60,77.55,472.30,62.05,457.35,22.20,445.15,-4.95,412.50,-13.25,375.40,-6.60,328.35,26.00,296.75,18.30,254.75,33.25,205.40,68.70,174.40,122.95,169.40,86.95,147.80,63.15,101.85,65.90,46.00,94.70,2.25,135.70,-13.25,184.40,-6.60,223.75,29.90,237.00,82.55,274.65,72.00,321.75,93.05,341.10,125.70,344.45,152.85,376.55,172.80,396.50,225.30,380.45,279.55,340.00,310.55,336.65,341.60,324.50,368.75,341.10,401.95,340.55,449.55,311.75,486.65,282.40,498.85,245.30,501.65,171.65,612.35,176.00,631.05,194.30,637.20,193.90,659.30];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_turtle_left.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 382.00;
	sprite.height = 655.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol92(this: IMayaAngelouCutouts_Symbol92) {
	return this;
}
function MayaAngelouCutouts_ang_turtle_left(this: IMayaAngelouCutouts_ang_turtle_left) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_turtle_left.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_turtle_right1(this: IMayaAngelouCutouts_ang_turtle_right1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [250.70,995.25,231.30,954.40,238.90,917.00,220.90,908.00,219.55,889.30,178.65,889.30,170.35,909.00,135.05,919.10,96.40,908.15,96.25,892.05,78.25,854.65,81.00,837.35,65.75,820.05,67.85,784.70,80.30,776.40,87.95,754.25,110.80,742.45,143.35,724.45,194.60,721.00,261.80,747.30,303.50,797.35,306.25,841.75,297.80,855.35,306.10,890.00,317.90,888.60,322.05,875.45,348.35,870.60,341.10,807.20,367.05,792.35,395.30,759.20,427.40,745.35,395.95,740.65,395.00,722.20,355.75,737.75,300.55,732.10,273.55,706.45,263.85,675.30,251.40,670.10,191.00,687.25,186.00,710.05,138.25,714.75,121.65,697.45,89.10,697.45,84.35,714.35,45.20,720.15,16.35,707.85,11.50,681.50,-7.20,678.05,-9.95,652.45,-0.95,643.40,4.70,616.10,35.45,580.80,91.15,561.00,148.65,570.00,176.25,595.85,191.00,617.15,221.60,606.90,255.00,609.40,268.15,621.80,289.80,617.50,315.00,625.00,343.60,622.35,350.00,605.10,379.65,604.65,392.70,619.90,409.30,621.25,362.35,472.35,349.05,461.25,311.75,453.25,283.95,430.75,266.35,386.85,270.80,344.20,263.20,306.00,273.55,265.25,295.00,244.45,310.25,202.30,353.90,178.05,352.50,151.70,331.75,113.65,325.50,69.30,338.80,22.35,373.60,-7.05,419.70,-13.80,474.40,11.10,496.05,47.10,502.10,92.15,519.30,111.10,528.45,146.20,561.00,154.50,588.70,184.30,597.70,228.60,588.95,267.85,563.75,293.00,571.40,331.75,564.45,374.00,586.60,395.45,601.35,431.70,599.90,475.80,581.10,511.80,544.35,533.30,525.65,536.75,511.80,552.00,469.55,690.55,472.05,708.95,492.55,713.90,496.45,737.15,527.80,746.65,551.05,762.70,566.55,770.90,578.45,796.40,590.65,807.45,590.75,840.10,580.55,902.35,551.30,909.40,547.85,926.70,509.75,936.40,476.50,929.45,468.75,906.20,423.15,909.40,416.25,924.60,397.55,934.30,393.40,969.65,373.30,995.25,339.35,1011.20,306.80,1013.95];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_turtle_right.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 589.00;
	sprite.height = 999.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol102(this: IMayaAngelouCutouts_Symbol102) {
	return this;
}
function MayaAngelouCutouts_ang_turtle_right(this: IMayaAngelouCutouts_ang_turtle_right) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_turtle_right.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_tutletastic_brad1(this: IMayaAngelouCutouts_ang_tutletastic_brad1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [319.55,33.95,352.80,79.75,363.90,162.20,386.75,178.10,390.90,223.85,370.10,266.15,320.90,273.05,327.15,282.75,394.35,277.25,419.35,327.80,402.00,381.80,358.35,378.35,334.75,388.75,373.60,481.65,326.45,490.00,343.80,505.95,337.55,546.10,302.20,560.00,255.05,557.20,214.20,537.10,169.80,553.75,111.60,546.10,87.35,520.50,97.05,478.20,119.90,470.60,133.10,413.75,92.90,404.05,67.25,335.40,77.65,302.15,56.85,279.95,20.80,277.90,-10.35,248.75,-15.90,190.55,11.10,169.05,11.80,99.85,53.40,21.50,147.35,-17.40,245.35,-5.60];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_tutletastic_brad.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 403.00;
	sprite.height = 545.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol95(this: IMayaAngelouCutouts_Symbol95) {
	return this;
}
function MayaAngelouCutouts_ang_tutletastic_brad(this: IMayaAngelouCutouts_ang_tutletastic_brad) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_tutletastic_brad.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_tutletastic_drz1(this: IMayaAngelouCutouts_ang_tutletastic_drz1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [227.45,4.20,284.30,50.65,310.65,112.35,304.45,169.90,328.00,174.05,350.90,204.50,352.25,255.80,334.95,294.60,303.75,297.40,274.60,326.50,260.75,357.70,260.75,391.00,241.35,410.40,226.75,430.50,185.85,440.25,165.05,421.50,160.90,397.25,151.20,395.85,140.80,422.90,90.20,436.05,56.20,425.00,59.00,375.75,36.80,353.55,-17.95,139.35,15.30,59.65,76.30,6.95,143.55,-13.15];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_tutletastic_drz.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 339.00;
	sprite.height = 426.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol96(this: IMayaAngelouCutouts_Symbol96) {
	return this;
}
function MayaAngelouCutouts_ang_tutletastic_drz(this: IMayaAngelouCutouts_ang_tutletastic_drz) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_tutletastic_drz.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_tutletastic_xavier1(this: IMayaAngelouCutouts_ang_tutletastic_xavier1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [33.25,71.30,97.50,97.20,144.75,62.10,202.10,39.10,199.10,12.50,216.00,-10.35,250.55,-8.65,265.45,10.45,277.75,10.75,290.60,-15.55,334.80,-7.75,372.00,34.30,379.90,88.50,405.95,118.90,418.95,185.65,431.95,201.25,451.15,165.65,518.95,185.05,528.25,227.95,511.90,255.30,486.35,263.60,348.70,385.95,374.35,552.40,409.45,569.90,412.00,612.25,385.15,632.30,328.50,636.15,282.80,622.75,229.80,637.05,163.00,637.90,134.95,612.30,140.45,569.60,184.80,551.60,185.65,532.55,210.40,523.85,213.40,401.55,52.10,342.55,-8.85,331.30,-8.15,288.80,31.25,282.75,26.95,256.80,51.20,247.15,63.35,214.20,66.80,144.85,41.65,144.00,6.70,150.75,-17.30,117.40,-2.20,78.15];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_tutletastic_xavier.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 514.00;
	sprite.height = 624.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol97(this: IMayaAngelouCutouts_Symbol97) {
	return this;
}
function MayaAngelouCutouts_ang_tutletastic_xavier(this: IMayaAngelouCutouts_ang_tutletastic_xavier) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_tutletastic_xavier.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_tutletastic_yadina1(this: IMayaAngelouCutouts_ang_tutletastic_yadina1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [331.05,22.80,381.00,43.90,430.40,-7.25,481.00,-13.85,509.85,28.35,508.75,87.80,432.65,112.75,444.90,165.45,463.75,191.55,459.35,240.45,503.75,247.65,516.55,286.00,506.00,322.10,468.80,320.95,410.40,361.50,369.90,375.40,374.90,417.05,390.45,431.50,419.90,423.70,457.10,430.90,468.25,466.50,420.95,558.70,377.10,562.05,341.60,520.95,308.80,499.30,281.05,530.40,267.15,564.25,243.85,578.70,203.85,573.70,169.40,538.15,156.10,482.65,176.65,440.40,216.60,442.10,226.05,429.30,225.50,377.60,130.55,358.20,88.30,360.40,75.55,315.95,96.65,268.75,91.65,236.00,105.00,212.10,97.75,161.05,-3.85,146.55,-18.30,86.60,12.80,37.20,67.80,43.85,128.30,81.60,183.30,36.10,277.15,15.00];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_tutletastic_yadina.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 502.00;
	sprite.height = 566.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol98(this: IMayaAngelouCutouts_Symbol98) {
	return this;
}
function MayaAngelouCutouts_ang_tutletastic_yadina(this: IMayaAngelouCutouts_ang_tutletastic_yadina) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_tutletastic_yadina.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_wings_cloud11(this: IMayaAngelouCutouts_ang_wings_cloud11) {
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_wings_cloud1.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1067.00;
	sprite.height = 183.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_ang_wings_cloud1(this: IMayaAngelouCutouts_ang_wings_cloud1) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_wings_cloud1.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_wings_cloud21(this: IMayaAngelouCutouts_ang_wings_cloud21) {
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_wings_cloud2.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1190.00;
	sprite.height = 501.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_ang_wings_cloud2(this: IMayaAngelouCutouts_ang_wings_cloud2) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_wings_cloud2.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_wings_cloud31(this: IMayaAngelouCutouts_ang_wings_cloud31) {
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_wings_cloud3.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1407.00;
	sprite.height = 365.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_ang_wings_cloud3(this: IMayaAngelouCutouts_ang_wings_cloud3) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_wings_cloud3.png", 0.000, 0.000);
	return this;
}
function MayaAngelouCutouts_ang_wings_drz1(this: IMayaAngelouCutouts_ang_wings_drz1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [996.70,148.05,1049.70,97.80,1131.15,85.55,1174.35,121.10,1193.85,209.25,1163.75,268.90,1120.30,275.70,1068.70,328.65,1148.80,361.25,1217.55,363.40,1260.20,399.80,1476.70,556.55,1615.10,710.15,1618.40,763.20,1585.30,763.70,1559.40,738.70,1330.80,680.05,1299.25,705.60,1273.75,662.70,1201.00,641.25,1144.50,637.40,1091.80,658.60,1071.40,600.50,1006.20,547.25,962.75,547.25,965.50,480.70,860.15,517.40,843.45,566.35,805.65,587.65,758.65,576.10,741.45,537.60,760.70,502.35,740.05,482.10,703.35,498.85,661.00,488.85,644.30,454.90,646.95,421.25,512.20,409.25,458.50,427.60,443.35,387.05,296.85,318.50,248.45,319.15,252.80,263.70,175.00,153.25,33.75,44.60,-14.10,39.15,-8.65,-3.25,95.70,-18.45,306.55,5.45,547.80,72.85,651.05,117.40,695.60,129.35,721.75,164.15,880.40,254.35,922.75,251.10,945.95,251.30,968.25,252.55,985.85,209.15];
	}
	const sprite = this.sprite;
	MayaAngelouCutouts_ang_wings_drz.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1606.00;
	sprite.height = 751.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function MayaAngelouCutouts_Symbol99(this: IMayaAngelouCutouts_Symbol99) {
	return this;
}
function MayaAngelouCutouts_ang_wings_drz(this: IMayaAngelouCutouts_ang_wings_drz) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_wings_drz.png", 0.000, 0.000);
	return this;
}
interface IMayaAngelouCutoutsArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IMayaAngelouCutoutsContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IMayaAngelouCutoutsSprite extends IMayaAngelouCutoutsContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IMayaAngelouCutoutsText extends IMayaAngelouCutoutsContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IMayaAngelouCutoutsPolygon extends Array<number> {
}
interface IMayaAngelouCutouts {
	readonly cutouts: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_ang_afriend_berbie1|IMayaAngelouCutouts_ang_afriend_drz1|IMayaAngelouCutouts_ang_afriend_hearts1|IMayaAngelouCutouts_ang_afriend_icecream1|IMayaAngelouCutouts_ang_art1|IMayaAngelouCutouts_ang_art_drz1|IMayaAngelouCutouts_ang_balloon1|IMayaAngelouCutouts_ang_balloon_drz1|IMayaAngelouCutouts_ang_bread1|IMayaAngelouCutouts_ang_bread_drz1|IMayaAngelouCutouts_ang_counterpart1|IMayaAngelouCutouts_ang_counterpart_drz_11|IMayaAngelouCutouts_ang_counterpart_drz_21|IMayaAngelouCutouts_ang_dance_stereo1|IMayaAngelouCutouts_ang_flower1|IMayaAngelouCutouts_ang_flower_drz1|IMayaAngelouCutouts_ang_flower_left1|IMayaAngelouCutouts_ang_flower_right1|IMayaAngelouCutouts_ang_heart_11|IMayaAngelouCutouts_ang_heart_21|IMayaAngelouCutouts_ang_heart_31|IMayaAngelouCutouts_ang_heart_drz1|IMayaAngelouCutouts_ang_heart_drz_front1|IMayaAngelouCutouts_ang_lovedaton1|IMayaAngelouCutouts_ang_lovedaton_heart11|IMayaAngelouCutouts_ang_lovedaton_heart21|IMayaAngelouCutouts_ang_lovedaton_heart31|IMayaAngelouCutouts_ang_lovedaton_heart41|IMayaAngelouCutouts_ang_marshmallowsbg1|IMayaAngelouCutouts_ang_moon1|IMayaAngelouCutouts_ang_moon_drz1|IMayaAngelouCutouts_ang_moon_drz_front1|IMayaAngelouCutouts_ang_numberone1|IMayaAngelouCutouts_ang_onionrings1|IMayaAngelouCutouts_ang_onionrings_drz1|IMayaAngelouCutouts_ang_pie1|IMayaAngelouCutouts_ang_marshmallows11|IMayaAngelouCutouts_ang_marshmallows21|IMayaAngelouCutouts_ang_marshmallows31|IMayaAngelouCutouts_ang_pie_drz1|IMayaAngelouCutouts_ang_pillow1|IMayaAngelouCutouts_ang_pillow_drz1|IMayaAngelouCutouts_ang_pizzatower1|IMayaAngelouCutouts_ang_pizzatower2|IMayaAngelouCutouts_ang_pizzatower__xavier1|IMayaAngelouCutouts_ang_pizzatower_brad1|IMayaAngelouCutouts_ang_pizzatower_drz1|IMayaAngelouCutouts_ang_pizzatower_yadina1|IMayaAngelouCutouts_ang_raccoon1|IMayaAngelouCutouts_ang_raccoon_drz1|IMayaAngelouCutouts_ang_raccoon_drz_front1|IMayaAngelouCutouts_ang_sandwich1|IMayaAngelouCutouts_ang_sandwich_drz1|IMayaAngelouCutouts_ang_sea_bubbles11|IMayaAngelouCutouts_ang_sea_bubbles21|IMayaAngelouCutouts_ang_sea_drz1|IMayaAngelouCutouts_ang_sea_left1|IMayaAngelouCutouts_ang_sea_fish1|IMayaAngelouCutouts_ang_sea_right1|IMayaAngelouCutouts_ang_sea_whale1|IMayaAngelouCutouts_ang_shower1|IMayaAngelouCutouts_ang_shower_dzr1|IMayaAngelouCutouts_ang_shower_dzr_front1|IMayaAngelouCutouts_ang_shower_note11|IMayaAngelouCutouts_ang_shower_note21|IMayaAngelouCutouts_ang_shower_notes1|IMayaAngelouCutouts_ang_sittingstill1|IMayaAngelouCutouts_ang_sittingstill_clock1|IMayaAngelouCutouts_ang_sittingstill_clock_handHr1|IMayaAngelouCutouts_ang_sittingstill_clock_handMin1|IMayaAngelouCutouts_ang_sittingstill_drz1|IMayaAngelouCutouts_ang_sled1|IMayaAngelouCutouts_ang_sled_drz1|IMayaAngelouCutouts_ang_sled_pillow_back1|IMayaAngelouCutouts_ang_sled_pillow_front1|IMayaAngelouCutouts_ang_sleepyhead_bed1|IMayaAngelouCutouts_ang_sleepyhead_drz1|IMayaAngelouCutouts_ang_sleepyhead_z1|IMayaAngelouCutouts_ang_sleepyhead_zzz1|IMayaAngelouCutouts_ang_smart1|IMayaAngelouCutouts_ang_smart_drz1|IMayaAngelouCutouts_ang_spoon1|IMayaAngelouCutouts_ang_spoon_drz1|IMayaAngelouCutouts_ang_springs_butterflies_11|IMayaAngelouCutouts_ang_springs_butterflies_21|IMayaAngelouCutouts_ang_springs_drz1|IMayaAngelouCutouts_ang_springs_duck_left1|IMayaAngelouCutouts_ang_springs_duck_right1|IMayaAngelouCutouts_ang_springs_spring1|IMayaAngelouCutouts_ang_swing_bg1|IMayaAngelouCutouts_ang_swing_drz1|IMayaAngelouCutouts_ang_teaset1|IMayaAngelouCutouts_ang_turtle_drz1|IMayaAngelouCutouts_ang_turtle_left1|IMayaAngelouCutouts_ang_turtle_right1|IMayaAngelouCutouts_ang_tutletastic_brad1|IMayaAngelouCutouts_ang_tutletastic_drz1|IMayaAngelouCutouts_ang_tutletastic_xavier1|IMayaAngelouCutouts_ang_tutletastic_yadina1|IMayaAngelouCutouts_ang_wings_cloud11|IMayaAngelouCutouts_ang_wings_cloud21|IMayaAngelouCutouts_ang_wings_cloud31|IMayaAngelouCutouts_ang_wings_drz1>;
}
interface IMayaAngelouCutouts_ang_afriend_berbie1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol2>;
	readonly sprite: IMayaAngelouCutouts_ang_afriend_berbie;
}
interface IMayaAngelouCutouts_Symbol2 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_afriend_berbie extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_afriend_drz1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol3>;
	readonly sprite: IMayaAngelouCutouts_ang_afriend_drz;
}
interface IMayaAngelouCutouts_Symbol3 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_afriend_drz extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_afriend_hearts1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol100>;
	readonly sprite: IMayaAngelouCutouts_ang_afriend_hearts;
}
interface IMayaAngelouCutouts_Symbol100 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_afriend_hearts extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_afriend_icecream1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol8>;
	readonly sprite: IMayaAngelouCutouts_ang_afriend_icecream;
}
interface IMayaAngelouCutouts_Symbol8 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_afriend_icecream extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_art1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol1>;
	readonly sprite: IMayaAngelouCutouts_ang_art;
}
interface IMayaAngelouCutouts_Symbol1 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_art extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_art_drz1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol9>;
	readonly sprite: IMayaAngelouCutouts_ang_art_drz;
}
interface IMayaAngelouCutouts_Symbol9 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_art_drz extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_balloon1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol10>;
	readonly sprite: IMayaAngelouCutouts_ang_balloon;
}
interface IMayaAngelouCutouts_Symbol10 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_balloon extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_balloon_drz1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol11>;
	readonly sprite: IMayaAngelouCutouts_ang_balloon_drz;
}
interface IMayaAngelouCutouts_Symbol11 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_balloon_drz extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_bread1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol12>;
	readonly sprite: IMayaAngelouCutouts_ang_bread;
}
interface IMayaAngelouCutouts_Symbol12 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_bread extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_bread_drz1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol101>;
	readonly sprite: IMayaAngelouCutouts_ang_bread_drz;
}
interface IMayaAngelouCutouts_Symbol101 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_bread_drz extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_counterpart1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol14>;
	readonly sprite: IMayaAngelouCutouts_ang_counterpart;
}
interface IMayaAngelouCutouts_Symbol14 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_counterpart extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_counterpart_drz_11 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol15>;
	readonly sprite: IMayaAngelouCutouts_ang_counterpart_drz_1;
}
interface IMayaAngelouCutouts_Symbol15 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_counterpart_drz_1 extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_counterpart_drz_21 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol16>;
	readonly sprite: IMayaAngelouCutouts_ang_counterpart_drz_2;
}
interface IMayaAngelouCutouts_Symbol16 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_counterpart_drz_2 extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_dance_stereo1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol17>;
	readonly sprite: IMayaAngelouCutouts_ang_dance_stereo;
}
interface IMayaAngelouCutouts_Symbol17 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_dance_stereo extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_flower1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol18>;
	readonly sprite: IMayaAngelouCutouts_ang_flower;
}
interface IMayaAngelouCutouts_Symbol18 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_flower extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_flower_drz1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol19>;
	readonly sprite: IMayaAngelouCutouts_ang_flower_drz;
}
interface IMayaAngelouCutouts_Symbol19 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_flower_drz extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_flower_left1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol20>;
	readonly sprite: IMayaAngelouCutouts_ang_flower_left;
}
interface IMayaAngelouCutouts_Symbol20 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_flower_left extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_flower_right1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol21>;
	readonly sprite: IMayaAngelouCutouts_ang_flower_right;
}
interface IMayaAngelouCutouts_Symbol21 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_flower_right extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_heart_11 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol22>;
	readonly sprite: IMayaAngelouCutouts_ang_heart_1;
}
interface IMayaAngelouCutouts_Symbol22 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_heart_1 extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_heart_21 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol23>;
	readonly sprite: IMayaAngelouCutouts_ang_heart_2;
}
interface IMayaAngelouCutouts_Symbol23 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_heart_2 extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_heart_31 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol24>;
	readonly sprite: IMayaAngelouCutouts_ang_heart_3;
}
interface IMayaAngelouCutouts_Symbol24 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_heart_3 extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_heart_drz1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol25>;
	readonly sprite: IMayaAngelouCutouts_ang_heart_drz;
}
interface IMayaAngelouCutouts_Symbol25 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_heart_drz extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_heart_drz_front1 extends IMayaAngelouCutoutsContainer {
	readonly sprite: IMayaAngelouCutouts_ang_heart_drz_front;
}
interface IMayaAngelouCutouts_ang_heart_drz_front extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_lovedaton1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol26>;
	readonly sprite: IMayaAngelouCutouts_ang_lovedaton;
}
interface IMayaAngelouCutouts_Symbol26 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_lovedaton extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_lovedaton_heart11 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol27>;
	readonly sprite: IMayaAngelouCutouts_ang_lovedaton_heart1;
}
interface IMayaAngelouCutouts_Symbol27 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_lovedaton_heart1 extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_lovedaton_heart21 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol28>;
	readonly sprite: IMayaAngelouCutouts_ang_lovedaton_heart2;
}
interface IMayaAngelouCutouts_Symbol28 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_lovedaton_heart2 extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_lovedaton_heart31 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol29>;
	readonly sprite: IMayaAngelouCutouts_ang_lovedaton_heart3;
}
interface IMayaAngelouCutouts_Symbol29 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_lovedaton_heart3 extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_lovedaton_heart41 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol30>;
	readonly sprite: IMayaAngelouCutouts_ang_lovedaton_heart4;
}
interface IMayaAngelouCutouts_Symbol30 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_lovedaton_heart4 extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_marshmallowsbg1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol31>;
	readonly sprite: IMayaAngelouCutouts_ang_marshmallowsbg;
}
interface IMayaAngelouCutouts_Symbol31 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_marshmallowsbg extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_moon1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol33>;
	readonly sprite: IMayaAngelouCutouts_ang_moon;
}
interface IMayaAngelouCutouts_Symbol33 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_moon extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_moon_drz1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol34>;
	readonly sprite: IMayaAngelouCutouts_ang_moon_drz;
}
interface IMayaAngelouCutouts_Symbol34 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_moon_drz extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_moon_drz_front1 extends IMayaAngelouCutoutsContainer {
	readonly sprite: IMayaAngelouCutouts_ang_moon_drz_front;
}
interface IMayaAngelouCutouts_ang_moon_drz_front extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_numberone1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol35>;
	readonly sprite: IMayaAngelouCutouts_ang_numberone;
}
interface IMayaAngelouCutouts_Symbol35 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_numberone extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_onionrings1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol36>;
	readonly sprite: IMayaAngelouCutouts_ang_onionrings;
}
interface IMayaAngelouCutouts_Symbol36 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_onionrings extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_onionrings_drz1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol37>;
	readonly sprite: IMayaAngelouCutouts_ang_onionrings_drz;
}
interface IMayaAngelouCutouts_Symbol37 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_onionrings_drz extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_pie1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol38>;
	readonly sprite: IMayaAngelouCutouts_ang_pie;
}
interface IMayaAngelouCutouts_Symbol38 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_pie extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_marshmallows11 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol103>;
	readonly sprite: IMayaAngelouCutouts_ang_marshmallows1;
}
interface IMayaAngelouCutouts_Symbol103 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_marshmallows1 extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_marshmallows21 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol40>;
	readonly sprite: IMayaAngelouCutouts_ang_marshmallows2;
}
interface IMayaAngelouCutouts_Symbol40 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_marshmallows2 extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_marshmallows31 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol39>;
	readonly sprite: IMayaAngelouCutouts_ang_marshmallows3;
}
interface IMayaAngelouCutouts_Symbol39 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_marshmallows3 extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_pie_drz1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol41>;
	readonly sprite: IMayaAngelouCutouts_ang_pie_drz;
}
interface IMayaAngelouCutouts_Symbol41 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_pie_drz extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_pillow1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol42>;
	readonly sprite: IMayaAngelouCutouts_ang_pillow;
}
interface IMayaAngelouCutouts_Symbol42 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_pillow extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_pillow_drz1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol43>;
	readonly sprite: IMayaAngelouCutouts_ang_pillow_drz;
}
interface IMayaAngelouCutouts_Symbol43 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_pillow_drz extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_pizzatower1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol105>;
	readonly sprite: IMayaAngelouCutouts_ang_pizzatower;
}
interface IMayaAngelouCutouts_Symbol105 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_pizzatower extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_pizzatower2 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol104>;
	readonly sprite: IMayaAngelouCutouts_ang_pizzatower11;
}
interface IMayaAngelouCutouts_Symbol104 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_pizzatower11 extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_pizzatower__xavier1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol45>;
	readonly sprite: IMayaAngelouCutouts_ang_pizzatower__xavier;
}
interface IMayaAngelouCutouts_Symbol45 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_pizzatower__xavier extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_pizzatower_brad1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol46>;
	readonly sprite: IMayaAngelouCutouts_ang_pizzatower_brad;
}
interface IMayaAngelouCutouts_Symbol46 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_pizzatower_brad extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_pizzatower_drz1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol47>;
	readonly sprite: IMayaAngelouCutouts_ang_pizzatower_drz;
}
interface IMayaAngelouCutouts_Symbol47 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_pizzatower_drz extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_pizzatower_yadina1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol48>;
	readonly sprite: IMayaAngelouCutouts_ang_pizzatower_yadina;
}
interface IMayaAngelouCutouts_Symbol48 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_pizzatower_yadina extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_raccoon1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol49>;
	readonly sprite: IMayaAngelouCutouts_ang_raccoon;
}
interface IMayaAngelouCutouts_Symbol49 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_raccoon extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_raccoon_drz1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol50>;
	readonly sprite: IMayaAngelouCutouts_ang_raccoon_drz;
}
interface IMayaAngelouCutouts_Symbol50 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_raccoon_drz extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_raccoon_drz_front1 extends IMayaAngelouCutoutsContainer {
	readonly sprite: IMayaAngelouCutouts_ang_raccoon_drz_front;
}
interface IMayaAngelouCutouts_ang_raccoon_drz_front extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_sandwich1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol51>;
	readonly sprite: IMayaAngelouCutouts_ang_sandwich;
}
interface IMayaAngelouCutouts_Symbol51 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_sandwich extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_sandwich_drz1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol52>;
	readonly sprite: IMayaAngelouCutouts_ang_sandwich_drz;
}
interface IMayaAngelouCutouts_Symbol52 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_sandwich_drz extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_sea_bubbles11 extends IMayaAngelouCutoutsContainer {
	readonly sprite: IMayaAngelouCutouts_ang_sea_bubbles1;
}
interface IMayaAngelouCutouts_ang_sea_bubbles1 extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_sea_bubbles21 extends IMayaAngelouCutoutsContainer {
	readonly sprite: IMayaAngelouCutouts_ang_sea_bubbles2;
}
interface IMayaAngelouCutouts_ang_sea_bubbles2 extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_sea_drz1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol53>;
	readonly sprite: IMayaAngelouCutouts_ang_sea_drz;
}
interface IMayaAngelouCutouts_Symbol53 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_sea_drz extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_sea_left1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol55>;
	readonly sprite: IMayaAngelouCutouts_ang_sea_left;
}
interface IMayaAngelouCutouts_Symbol55 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_sea_left extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_sea_fish1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol54>;
	readonly sprite: IMayaAngelouCutouts_ang_sea_fish;
}
interface IMayaAngelouCutouts_Symbol54 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_sea_fish extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_sea_right1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol56|IMayaAngelouCutouts_Symbol57>;
	readonly sprite: IMayaAngelouCutouts_ang_sea_right;
}
interface IMayaAngelouCutouts_Symbol56 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_Symbol57 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_sea_right extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_sea_whale1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol58>;
	readonly sprite: IMayaAngelouCutouts_ang_sea_whale;
}
interface IMayaAngelouCutouts_Symbol58 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_sea_whale extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_shower1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol59>;
	readonly sprite: IMayaAngelouCutouts_ang_shower;
}
interface IMayaAngelouCutouts_Symbol59 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_shower extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_shower_dzr1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol60>;
	readonly sprite: IMayaAngelouCutouts_ang_shower_dzr;
}
interface IMayaAngelouCutouts_Symbol60 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_shower_dzr extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_shower_dzr_front1 extends IMayaAngelouCutoutsContainer {
	readonly sprite: IMayaAngelouCutouts_ang_shower_dzr_front;
}
interface IMayaAngelouCutouts_ang_shower_dzr_front extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_shower_note11 extends IMayaAngelouCutoutsContainer {
	readonly sprite: IMayaAngelouCutouts_ang_shower_note1;
}
interface IMayaAngelouCutouts_ang_shower_note1 extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_shower_note21 extends IMayaAngelouCutoutsContainer {
	readonly sprite: IMayaAngelouCutouts_ang_shower_note2;
}
interface IMayaAngelouCutouts_ang_shower_note2 extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_shower_notes1 extends IMayaAngelouCutoutsContainer {
	readonly sprite: IMayaAngelouCutouts_ang_shower_notes;
}
interface IMayaAngelouCutouts_ang_shower_notes extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_sittingstill1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol63>;
	readonly sprite: IMayaAngelouCutouts_ang_sittingstill;
}
interface IMayaAngelouCutouts_Symbol63 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_sittingstill extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_sittingstill_clock1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol64>;
	readonly sprite: IMayaAngelouCutouts_ang_sittingstill_clock;
}
interface IMayaAngelouCutouts_Symbol64 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_sittingstill_clock extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_sittingstill_clock_handHr1 extends IMayaAngelouCutoutsContainer {
	readonly sprite: IMayaAngelouCutouts_ang_sittingstill_clock_handHr;
}
interface IMayaAngelouCutouts_ang_sittingstill_clock_handHr extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_sittingstill_clock_handMin1 extends IMayaAngelouCutoutsContainer {
	readonly sprite: IMayaAngelouCutouts_ang_sittingstill_clock_handMin;
}
interface IMayaAngelouCutouts_ang_sittingstill_clock_handMin extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_sittingstill_drz1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol65>;
	readonly sprite: IMayaAngelouCutouts_ang_sittingstill_drz;
}
interface IMayaAngelouCutouts_Symbol65 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_sittingstill_drz extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_sled1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol66>;
	readonly sprite: IMayaAngelouCutouts_ang_sled;
}
interface IMayaAngelouCutouts_Symbol66 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_sled extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_sled_drz1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol67>;
	readonly sprite: IMayaAngelouCutouts_ang_sled_drz;
}
interface IMayaAngelouCutouts_Symbol67 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_sled_drz extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_sled_pillow_back1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol68|IMayaAngelouCutouts_Symbol69>;
	readonly sprite: IMayaAngelouCutouts_ang_sled_pillow_back;
}
interface IMayaAngelouCutouts_Symbol68 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_Symbol69 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_sled_pillow_back extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_sled_pillow_front1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol70>;
	readonly sprite: IMayaAngelouCutouts_ang_sled_pillow_front;
}
interface IMayaAngelouCutouts_Symbol70 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_sled_pillow_front extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_sleepyhead_bed1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol71>;
	readonly sprite: IMayaAngelouCutouts_ang_sleepyhead_bed;
}
interface IMayaAngelouCutouts_Symbol71 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_sleepyhead_bed extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_sleepyhead_drz1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol72>;
	readonly sprite: IMayaAngelouCutouts_ang_sleepyhead_drz;
}
interface IMayaAngelouCutouts_Symbol72 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_sleepyhead_drz extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_sleepyhead_z1 extends IMayaAngelouCutoutsContainer {
	readonly sprite: IMayaAngelouCutouts_ang_sleepyhead_z;
}
interface IMayaAngelouCutouts_ang_sleepyhead_z extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_sleepyhead_zzz1 extends IMayaAngelouCutoutsContainer {
	readonly sprite: IMayaAngelouCutouts_ang_sleepyhead_zzz;
}
interface IMayaAngelouCutouts_ang_sleepyhead_zzz extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_smart1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol73>;
	readonly sprite: IMayaAngelouCutouts_ang_smart;
}
interface IMayaAngelouCutouts_Symbol73 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_smart extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_smart_drz1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol74>;
	readonly sprite: IMayaAngelouCutouts_ang_smart_drz;
}
interface IMayaAngelouCutouts_Symbol74 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_smart_drz extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_spoon1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol75>;
	readonly sprite: IMayaAngelouCutouts_ang_spoon;
}
interface IMayaAngelouCutouts_Symbol75 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_spoon extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_spoon_drz1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol76>;
	readonly sprite: IMayaAngelouCutouts_ang_spoon_drz;
}
interface IMayaAngelouCutouts_Symbol76 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_spoon_drz extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_springs_butterflies_11 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol77|IMayaAngelouCutouts_Symbol78|IMayaAngelouCutouts_Symbol79>;
	readonly sprite: IMayaAngelouCutouts_ang_springs_butterflies_1;
}
interface IMayaAngelouCutouts_Symbol77 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_Symbol78 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_Symbol79 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_springs_butterflies_1 extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_springs_butterflies_21 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol80|IMayaAngelouCutouts_Symbol81|IMayaAngelouCutouts_Symbol82>;
	readonly sprite: IMayaAngelouCutouts_ang_springs_butterflies_2;
}
interface IMayaAngelouCutouts_Symbol80 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_Symbol81 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_Symbol82 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_springs_butterflies_2 extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_springs_drz1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol83>;
	readonly sprite: IMayaAngelouCutouts_ang_springs_drz;
}
interface IMayaAngelouCutouts_Symbol83 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_springs_drz extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_springs_duck_left1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol84>;
	readonly sprite: IMayaAngelouCutouts_ang_springs_duck_left;
}
interface IMayaAngelouCutouts_Symbol84 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_springs_duck_left extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_springs_duck_right1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol85>;
	readonly sprite: IMayaAngelouCutouts_ang_springs_duck_right;
}
interface IMayaAngelouCutouts_Symbol85 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_springs_duck_right extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_springs_spring1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol86>;
	readonly sprite: IMayaAngelouCutouts_ang_springs_spring;
}
interface IMayaAngelouCutouts_Symbol86 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_springs_spring extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_swing_bg1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol88|IMayaAngelouCutouts_Symbol87>;
	readonly sprite: IMayaAngelouCutouts_ang_swing_bg;
}
interface IMayaAngelouCutouts_Symbol88 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_Symbol87 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_swing_bg extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_swing_drz1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol89>;
	readonly sprite: IMayaAngelouCutouts_ang_swing_drz;
}
interface IMayaAngelouCutouts_Symbol89 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_swing_drz extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_teaset1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol90>;
	readonly sprite: IMayaAngelouCutouts_ang_teaset;
}
interface IMayaAngelouCutouts_Symbol90 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_teaset extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_turtle_drz1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol91>;
	readonly sprite: IMayaAngelouCutouts_ang_turtle_drz;
}
interface IMayaAngelouCutouts_Symbol91 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_turtle_drz extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_turtle_left1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol92>;
	readonly sprite: IMayaAngelouCutouts_ang_turtle_left;
}
interface IMayaAngelouCutouts_Symbol92 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_turtle_left extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_turtle_right1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol102>;
	readonly sprite: IMayaAngelouCutouts_ang_turtle_right;
}
interface IMayaAngelouCutouts_Symbol102 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_turtle_right extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_tutletastic_brad1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol95>;
	readonly sprite: IMayaAngelouCutouts_ang_tutletastic_brad;
}
interface IMayaAngelouCutouts_Symbol95 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_tutletastic_brad extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_tutletastic_drz1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol96>;
	readonly sprite: IMayaAngelouCutouts_ang_tutletastic_drz;
}
interface IMayaAngelouCutouts_Symbol96 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_tutletastic_drz extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_tutletastic_xavier1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol97>;
	readonly sprite: IMayaAngelouCutouts_ang_tutletastic_xavier;
}
interface IMayaAngelouCutouts_Symbol97 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_tutletastic_xavier extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_tutletastic_yadina1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol98>;
	readonly sprite: IMayaAngelouCutouts_ang_tutletastic_yadina;
}
interface IMayaAngelouCutouts_Symbol98 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_tutletastic_yadina extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_wings_cloud11 extends IMayaAngelouCutoutsContainer {
	readonly sprite: IMayaAngelouCutouts_ang_wings_cloud1;
}
interface IMayaAngelouCutouts_ang_wings_cloud1 extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_wings_cloud21 extends IMayaAngelouCutoutsContainer {
	readonly sprite: IMayaAngelouCutouts_ang_wings_cloud2;
}
interface IMayaAngelouCutouts_ang_wings_cloud2 extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_wings_cloud31 extends IMayaAngelouCutoutsContainer {
	readonly sprite: IMayaAngelouCutouts_ang_wings_cloud3;
}
interface IMayaAngelouCutouts_ang_wings_cloud3 extends IMayaAngelouCutoutsSprite {
}
interface IMayaAngelouCutouts_ang_wings_drz1 extends IMayaAngelouCutoutsContainer {
	readonly polygons: IMayaAngelouCutoutsArray<IMayaAngelouCutouts_Symbol99>;
	readonly sprite: IMayaAngelouCutouts_ang_wings_drz;
}
interface IMayaAngelouCutouts_Symbol99 extends IMayaAngelouCutoutsPolygon {
}
interface IMayaAngelouCutouts_ang_wings_drz extends IMayaAngelouCutoutsSprite {
}
